/**
 * Florame CAP & Stock System - INLINE MODULE v31.0
 * Based on UNIFIED CAP LOGIC provided.
 * Features: Session Tokens, Robust Autocomplete, Backend Validation.
 */
(function () {
    const CONFIG = {
        stockEndpoint: "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/getStockByCap",
        addressAutocomplete: "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/addressAutocomplete",
        addressResolve: "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/addressResolve",
        capValidityMs: 2 * 60 * 60 * 1000, // 2 hours

        // ✅ CAP fuori copertura → raccolta email (Firebase)
        coverageWaitlistEndpoint: "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/collectCoverageWaitlist",
        privacyUrl: "/policies/privacy-policy"
    };
    
    const STORAGE_KEY = 'florame_cap_state';
    const ADDR_CACHE_KEY = 'florame_last_address';
    const $ = (id) => document.getElementById(id);


    // ───────────────────────────────────────────────────────────────
    // 📍 address_attempts logging (FONDAMENTALE: già integrato in AWI, parità su Home)
    // Cloud Function: logAddressAttempt -> Firestore collection: address_attempts
    // ───────────────────────────────────────────────────────────────
    const LOG_ATTEMPT_ENDPOINT = "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/logAddressAttempt";
    const SESSION_ID_KEY = 'florame_cap_session_id';

    function __getSessionId() {
        try {
            const existing = localStorage.getItem(SESSION_ID_KEY);
            if (existing) return existing;
            const sid = (window.crypto && typeof window.crypto.randomUUID === 'function')
                ? window.crypto.randomUUID()
                : ('sid_' + Math.random().toString(16).slice(2) + Date.now().toString(16));
            localStorage.setItem(SESSION_ID_KEY, sid);
            return sid;
        } catch (_) {
            return 'sid_' + Math.random().toString(16).slice(2);
        }
    }

        function __newAddressAttemptId(prefix) {
            try {
                const id = (window.crypto && typeof window.crypto.randomUUID === 'function')
                    ? window.crypto.randomUUID()
                    : (Date.now().toString(36) + '_' + Math.random().toString(36).slice(2));
                return String(prefix || 'address_attempt') + '_' + id;
            } catch (_) {
                return String(prefix || 'address_attempt') + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
            }
        }

        function __addressAttemptPageMeta() {
            try {
                let tz = '';
                try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_) {}
                return {
                    page: String((window.location && window.location.href) || '').slice(0, 1000),
                    referrer: String(document.referrer || '').slice(0, 1000),
                    locale: String((document.documentElement && document.documentElement.lang) || navigator.language || '').slice(0, 32),
                    tz: String(tz || '').slice(0, 64)
                };
            } catch (_) { return {}; }
        }

        function __normalizeAttemptPayload(p) {
            try {
                const payload = p || {};
                const status = String(payload.status || '').trim();
                const q = String(payload.query ?? payload.input ?? payload.display ?? payload.resolvedDisplay ?? '').trim();
                const d = String(payload.display ?? payload.resolvedDisplay ?? payload.query ?? payload.input ?? '').trim();

                let isAddr = payload.isAddress;
                if (typeof isAddr !== 'boolean') {
                    if (status === 'success' || status === 'not_served' || status === 'start') isAddr = true;
                    else if (status === 'invalid_address' || status === 'missing_selection' || status === 'resolve_error') isAddr = false;
                }

                const out = { ...(payload || {}) };
                if (!out.query && q) out.query = q;
                if (!out.display && d) out.display = d;
                if (typeof out.isAddress !== 'boolean' && typeof isAddr === 'boolean') out.isAddress = isAddr;
                return out;
            } catch (_) { return p || {}; }
        }

        function __logAddressAttempt(payload) {
            try {
                const customerEmail = String(
                    (payload && (payload.customerEmail || payload.email)) ||
                    (typeof __coverageGetPrefillEmail === 'function' ? __coverageGetPrefillEmail() : '') ||
                    ''
                ).trim().toLowerCase();
                const body = { ...__addressAttemptPageMeta(), ...__normalizeAttemptPayload(payload), sessionId: __getSessionId(), customerEmail };
                fetch(LOG_ATTEMPT_ENDPOINT, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
                    keepalive: true
                }).catch(() => {});
            } catch (_) {}
        }
    // --- HELPERS (Ported from Unified Logic) ---

    function __uuidv4() {
        try { if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID(); } catch (_) {}
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    }

    function ensureSessionToken(input) {
        if (!input.dataset.sessionToken) input.dataset.sessionToken = __uuidv4();
        return input.dataset.sessionToken;
    }

    function resetSessionToken(input) { delete input.dataset.sessionToken; }

    function __formatAddrSuggestion(s) {
        const text = s.text || s.display || s.label || '';
        const main = s.mainText || (s.structuredFormat && s.structuredFormat.mainText && s.structuredFormat.mainText.text) || '';
        const secondary = s.secondaryText || (s.structuredFormat && s.structuredFormat.secondaryText && s.structuredFormat.secondaryText.text) || '';
        const pcHint = s.postcodeHint || s.postcode || s.postalCode || '';
        
        const mainShort = (main || (text.split(',')[0] || text)).trim();
        const subNoCap = String(secondary || '').trim();
        const sub = [pcHint, subNoCap].filter(Boolean).join(' · ');

        return {
            ...s,
            display: text || [mainShort, subNoCap].filter(Boolean).join(', '),
            __mainShort: mainShort || text,
            __sub: sub,
            __subNoCap: subNoCap,
            __postcode: pcHint || ''
        };
    }


    // ───────────────────────────────────────────────────────────────
    // Address Book (Recenti + Salvati) — shared with Florame App
    // Storage: localStorage['florame_address_book_v1']
    // ───────────────────────────────────────────────────────────────
    const __ADDR_BOOK_KEY = 'florame_address_book_v1';
    const __ADDR_BOOK_MAX_RECENT = 10;
    const __ADDR_BOOK_MAX_SAVED = 20;

    function __addrBookSafeParse(raw) {
        try { return raw ? JSON.parse(raw) : null; } catch (_) { return null; }
    }
    function __addrBookLoad() {
        const base = { v: 1, recent: [], saved: [] };
        try {
            const data = __addrBookSafeParse(localStorage.getItem(__ADDR_BOOK_KEY));
            if (!data || typeof data !== 'object') return base;
            return {
                v: 1,
                recent: Array.isArray(data.recent) ? data.recent : [],
                saved: Array.isArray(data.saved) ? data.saved : []
            };
        } catch (_) { return base; }
    }
    function __addrBookSave(book) {
        try { localStorage.setItem(__ADDR_BOOK_KEY, JSON.stringify(book)); } catch (_) {}
    }
    function __addrBookNormalize(entry) {
        const placeId = String(entry?.placeId || entry?.place_id || '').trim();
        if (!placeId) return null;
        const display = String(entry?.display || entry?.text || entry?.label || '').trim();
        const postcode = String(entry?.postcode || entry?.postalCode || entry?.__postcode || '').trim();
        const name = String(entry?.name || '').trim();
        return {
            placeId,
            display,
            postcode: (/^\d{5}$/.test(postcode) ? postcode : ''),
            name,
            tsUsed: Number(entry?.tsUsed || entry?.ts || 0) || 0,
            tsSaved: Number(entry?.tsSaved || 0) || 0
        };
    }
    function __addrBookIsSaved(placeId) {
        const pid = String(placeId || '').trim();
        if (!pid) return false;
        try { return (__addrBookLoad().saved || []).some(x => String(x?.placeId || '') === pid); } catch (_) { return false; }
    }
    function __addrBookUpsertRecent(entry) {
        const e = __addrBookNormalize(entry);
        if (!e || !e.display) return;
        const book = __addrBookLoad();
        const now = Date.now();

        // Update saved record if present
        const sIdx = (book.saved || []).findIndex(x => String(x?.placeId || '') === e.placeId);
        if (sIdx >= 0) {
            const cur = __addrBookNormalize(book.saved[sIdx]) || {};
            book.saved[sIdx] = { ...cur, placeId: e.placeId, display: e.display || cur.display || '', postcode: e.postcode || cur.postcode || '', name: cur.name || '', tsSaved: Number(cur.tsSaved || now) || now, tsUsed: now };
        }

        book.recent = (book.recent || []).filter(x => String(x?.placeId || '') !== e.placeId);
        book.recent.unshift({ placeId: e.placeId, display: e.display, postcode: e.postcode, tsUsed: now });
        book.recent = (book.recent || []).slice(0, __ADDR_BOOK_MAX_RECENT);
        __addrBookSave(book);
    }
    function __addrBookUpsertSaved(entry, name) {
        const e = __addrBookNormalize(entry);
        const n = String(name || '').trim();
        if (!e || !e.display || !n) return;

        const book = __addrBookLoad();
        const now = Date.now();
        const idx = (book.saved || []).findIndex(x => String(x?.placeId || '') === e.placeId);
        if (idx >= 0) {
            const cur = __addrBookNormalize(book.saved[idx]) || {};
            book.saved[idx] = { ...cur, placeId: e.placeId, display: e.display || cur.display || '', postcode: e.postcode || cur.postcode || '', name: n, tsSaved: Number(cur.tsSaved || now) || now, tsUsed: now };
        } else {
            book.saved = Array.isArray(book.saved) ? book.saved : [];
            book.saved.unshift({ placeId: e.placeId, display: e.display, postcode: e.postcode, name: n, tsSaved: now, tsUsed: now });
        }
        book.saved = (book.saved || []).filter(x => x && x.placeId && x.display);
        book.saved.sort((a, b) => Number(b.tsSaved || 0) - Number(a.tsSaved || 0));
        book.saved = book.saved.slice(0, __ADDR_BOOK_MAX_SAVED);

        __addrBookSave(book);
        __addrBookUpsertRecent(e);
    }
    function __addrBookRemove(placeId) {
        const pid = String(placeId || '').trim();
        if (!pid) return;
        const book = __addrBookLoad();
        book.saved = (book.saved || []).filter(x => String(x?.placeId || '') !== pid);
        book.recent = (book.recent || []).filter(x => String(x?.placeId || '') !== pid);
        __addrBookSave(book);
    }
    function __addrBookSections() {
        const book = __addrBookLoad();
        const saved = (book.saved || []).map(__addrBookNormalize).filter(Boolean);
        const savedIds = new Set(saved.map(x => x.placeId));
        const recent = (book.recent || []).map(__addrBookNormalize).filter(x => x && !savedIds.has(x.placeId));
        saved.sort((a, b) => Number(b.tsSaved || 0) - Number(a.tsSaved || 0));
        recent.sort((a, b) => Number(b.tsUsed || 0) - Number(a.tsUsed || 0));
        return { saved, recent };
    }


    function __addrBookSavedName(placeId) {
        const pid = String(placeId || '').trim();
        if (!pid) return '';
        try {
            const { saved } = __addrBookSections();
            const hit = (saved || []).find(x => String(x?.placeId || '').trim() === pid);
            return String(hit?.name || '').trim();
        } catch (_) { return ''; }
    }
    function __addrKey(str) {
        return String(str || '')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .replace(/\u00A0/g, ' ')
            .replace(/[’']/g, "'")
            .trim();
    }


function __addrKeyLoose(str) {
  return __addrKey(str)
    .replace(/[.,;:()\[\]{}]/g, ' ')
    .replace(/[\/\\\-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Best match from Address Book for pinning (exact or "similar" while typing)
function __addrBookBestMatch(typed) {
  const raw = String(typed || '').trim();
  if (!raw) return null;

  const t = __addrKeyLoose(__cleanAddress(raw));
  const tCompactLen = t.replace(/\s/g, '').length;
  if (!t) return null;

  const { saved, recent } = __addrBookSections();

  const scoreOf = (entry) => {
    const cand = __addrKeyLoose(__cleanAddress(String(entry?.display || '')));
    if (!cand) return 0;

    // Exact match
    if (cand === t) return 100;

    // only allow fuzzy when user typed enough (>= 3 non-space chars)
    if (tCompactLen < 3) return 0;

    // Strong prefix relationships feel the most natural while typing
    if (cand.startsWith(t)) return 92;
    if (t.startsWith(cand)) return 88;

    // Contains is still a good signal
    if (cand.includes(t)) return 82;

    // Token overlap (handles reorderings)
    const toks = t.split(' ').filter(Boolean).filter(x => x.length >= 2);
    if (!toks.length) return 0;

    let hit = 0;
    for (const tok of toks) {
      if (cand.includes(tok)) hit++;
    }
    const ratio = hit / toks.length;

    if (ratio >= 0.8) return 78;
    if (ratio >= 0.6) return 72;
    if (ratio >= 0.5 && toks.length >= 3) return 70;

    return 0;
  };

  let best = null;
  let bestScope = '';
  let bestScore = 0;

  const scan = (arr, scope) => {
    for (const e of (arr || [])) {
      const sc = scoreOf(e);
      if (sc > bestScore || (sc === bestScore && best && bestScope === 'recent' && scope === 'saved')) {
        best = e; bestScope = scope; bestScore = sc;
      }
    }
  };

  scan(saved, 'saved');
  scan(recent, 'recent');

  if (!best || !best?.placeId) return null;

  // Threshold: always allow exact; otherwise require decent score (prefix/contains)
  if (bestScore < 70 && bestScore !== 100) return null;

  return { entry: best, scope: bestScope, score: bestScore };
}

            // SVG icons (inline, scalable, theme-friendly)
            const __SVG_STAR_OUTLINE = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 17.27l-5.18 3.05 1.4-5.98L3 9.24l6.07-.52L12 3l2.93 5.72 6.07.52-5.22 5.1 1.4 5.98z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>`;
            const __SVG_STAR_FILLED  = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 17.27l-5.18 3.05 1.4-5.98L3 9.24l6.07-.52L12 3l2.93 5.72 6.07.52-5.22 5.1 1.4 5.98z" fill="currentColor"/></svg>`;
            const __SVG_TRASH        = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6M14 10V17M10 10V17" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`;

    function __ensureAddrNameModal() {
        if (window.__homeAddrNameModal) return window.__homeAddrNameModal;

        const overlay = document.createElement('div');
        overlay.className = 'addr-modal-overlay';
        overlay.innerHTML = `
          <div class="addr-modal" role="dialog" aria-modal="true" aria-labelledby="addrHomeModalTitle">
            <div class="addr-modal-head" id="addrHomeModalTitle">Salva indirizzo</div>
            <div class="addr-modal-body">
              <label class="addr-modal-label" for="addrHomeModalInput">Nome</label>
              <input id="addrHomeModalInput" class="addr-modal-input" type="text" inputmode="text" autocomplete="off" autocapitalize="words" />
            </div>
            <div class="addr-modal-foot">
              <button type="button" class="addr-modal-btn cancel">Annulla</button>
              <button type="button" class="addr-modal-btn confirm">Salva</button>
            </div>
          </div>
        `;
        document.body.appendChild(overlay);

        const titleEl = overlay.querySelector('#addrHomeModalTitle');
        const inputEl = overlay.querySelector('#addrHomeModalInput');
        const btnCancel = overlay.querySelector('.addr-modal-btn.cancel');
        const btnOk = overlay.querySelector('.addr-modal-btn.confirm');

        let __resolve = null;
        let __prevOverflow = '';
        let __scrollY = 0;
        let __prevBody = null;
        let __vvCleanup = null;

        const __lockScroll = () => {
          try {
            __prevOverflow = document.documentElement.style.overflow || '';
            document.documentElement.style.overflow = 'hidden';
          } catch (_) { }
          // iOS-friendly: lock body scroll without layout jump
          try {
            __scrollY = window.scrollY || window.pageYOffset || 0;
            __prevBody = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left,
                right: document.body.style.right,
                width: document.body.style.width
            };
            document.body.style.position = 'fixed';
            document.body.style.top = (-__scrollY) + 'px';
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
          } catch (_) { }
        };

        const __unlockScroll = () => {
          try { document.documentElement.style.overflow = __prevOverflow || ''; } catch (_) { }
          try {
            if (__prevBody) {
                document.body.style.position = __prevBody.position || '';
                document.body.style.top = __prevBody.top || '';
                document.body.style.left = __prevBody.left || '';
                document.body.style.right = __prevBody.right || '';
                document.body.style.width = __prevBody.width || '';
            }
            window.scrollTo(0, __scrollY || 0);
          } catch (_) { }
          __prevBody = null;
        };

        const __syncVV = () => {
          try {
            const vv = window.visualViewport;
            const vvH = (vv && vv.height) ? vv.height : window.innerHeight;
            overlay.style.setProperty('--addrVVH', vvH + 'px');

            // Move modal up when the virtual keyboard reduces the visual viewport
            const layoutH = window.innerHeight || vvH;
            const centerVV = (vv && typeof vv.offsetTop === 'number') ? (vv.offsetTop + vvH / 2) : (vvH / 2);
            const centerLayout = layoutH / 2;
            let shift = centerVV - centerLayout; // negative => move up
            // Only allow upward shift, cap to avoid going off-screen
            if (shift > 0) shift = 0;
            if (shift < -260) shift = -260;
            overlay.style.setProperty('--addrModalShift', shift + 'px');
          } catch (_) { }
        };

        const __attachVV = () => {
          if (__vvCleanup) return;
          let raf = 0;
          const onVV = () => {
            try { if (raf) cancelAnimationFrame(raf); } catch (_) { }
            raf = requestAnimationFrame(() => { __syncVV(); });
          };

          const vv = window.visualViewport;
          try { window.addEventListener('resize', onVV, { passive: true }); } catch (_) { }
          try { window.addEventListener('orientationchange', onVV, { passive: true }); } catch (_) { }

          if (vv && vv.addEventListener) {
            try { vv.addEventListener('resize', onVV, { passive: true }); } catch (_) { }
            try { vv.addEventListener('scroll', onVV, { passive: true }); } catch (_) { }
          }

          __vvCleanup = () => {
            try { window.removeEventListener('resize', onVV); } catch (_) { }
            try { window.removeEventListener('orientationchange', onVV); } catch (_) { }
            if (vv && vv.removeEventListener) {
                try { vv.removeEventListener('resize', onVV); } catch (_) { }
                try { vv.removeEventListener('scroll', onVV); } catch (_) { }
            }
            try { if (raf) cancelAnimationFrame(raf); } catch (_) { }
            raf = 0;
            __vvCleanup = null;
          };

          // initial
          setTimeout(__syncVV, 0);
          setTimeout(__syncVV, 80);
        };

        const __detachVV = () => {
          try { if (__vvCleanup) __vvCleanup(); } catch (_) { }
          __vvCleanup = null;
          try { overlay.style.removeProperty('--addrModalShift'); } catch (_) { }
          try { overlay.style.removeProperty('--addrVVH'); } catch (_) { }
        };

        
        const close = (val) => {
            try { overlay.style.display = 'none'; } catch (_) { }
            try { __detachVV(); } catch (_) { }
            try { __unlockScroll(); } catch (_) { }
            const r = __resolve;
            __resolve = null;
            if (typeof r === 'function') r(val);
        };

        const syncBtn = () => { btnOk.disabled = !String(inputEl.value || '').trim(); };

        overlay.addEventListener('click', (ev) => { if (ev.target === overlay) close(null); });
        btnCancel.addEventListener('click', () => close(null));
        btnOk.addEventListener('click', () => { const v = String(inputEl.value || '').trim(); if (!v) return; close(v); });
        inputEl.addEventListener('input', syncBtn);
        inputEl.addEventListener('keydown', (ev) => {
            if (ev.key === 'Escape') { ev.preventDefault(); close(null); return; }
            if (ev.key === 'Enter') { ev.preventDefault(); const v = String(inputEl.value || '').trim(); if (!v) return; close(v); }
        });

        window.__homeAddrNameModal = {
            open: ({ title, initialValue, confirmText } = {}) => new Promise((resolve) => {
                __resolve = resolve;
                try { __lockScroll(); } catch (_) { }
                try { titleEl.textContent = String(title || 'Salva indirizzo'); } catch (_) { }
                try { btnOk.textContent = String(confirmText || 'Salva'); } catch (_) { }
                try { inputEl.value = String(initialValue || ''); } catch (_) { }
                syncBtn();
                try { overlay.style.display = 'flex'; } catch (_) { }
                try { __attachVV(); } catch (_) { }
                setTimeout(() => { try { __syncVV(); } catch (_) { } }, 0);
                setTimeout(() => { try { inputEl.focus(); inputEl.select(); } catch (_) { } }, 60);
            })
        };
        return window.__homeAddrNameModal;
    }

    function __ensureAddrQuickStyles() {
        if (document.getElementById('addr-quick-style')) return;
        const style = document.createElement('style');
        style.id = 'addr-quick-style';
        style.textContent = `
          .addr-quick{padding:10px 10px}
          .addr-quick-section{margin-top:6px}
          .addr-quick-head{display:flex;align-items:center;justify-content:space-between;font-size:11px;letter-spacing:.08em;text-transform:uppercase;opacity:.7;padding:6px 4px}
          .addr-quick-empty{padding:12px 14px;font-size:13px;opacity:.7}
          .addr-quick-item{display:flex;align-items:center;gap:10px}
          .addr-actions{margin-left:auto;display:flex;gap:8px;flex:0 0 auto}
          .addr-act{width:32px;height:32px;border-radius:999px;border:0;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;background:rgba(17,24,39,0.06);color:rgba(17,24,39,0.85)}
          .addr-act svg{width:18px;height:18px;display:block}
          .addr-act:hover{background:rgba(17,24,39,0.10)}
          .addr-act:active{transform:scale(0.96)}
          .addr-act.addr-del{background:rgba(255,77,117,0.12);color:#ff4d75}
        

          .addr-saved-chip{display:inline-flex;align-items:center;justify-content:center;max-width:140px;overflow:hidden;text-overflow:ellipsis;padding:6px 10px;border-radius:999px;background:rgba(255,77,117,0.14);color:#ff4d75;font-weight:900;font-size:12px;line-height:1;white-space:nowrap}
          .addr-item.is-pinned{outline:2px solid rgba(255,77,117,0.22);outline-offset:2px}

          .addr-modal-overlay{position:fixed;inset:0;z-index:2147483000;display:none;align-items:stretch;justify-content:stretch;padding:calc(16px + env(safe-area-inset-top)) 16px calc(16px + env(safe-area-inset-bottom));background:rgba(17,24,39,0.52);backdrop-filter:saturate(120%) blur(6px);overflow:auto;-webkit-overflow-scrolling:touch}
          .addr-modal{width:min(440px,100%);border-radius:18px;background:#fff;box-shadow:0 28px 80px rgba(0,0,0,0.30);overflow:hidden;display:flex;flex-direction:column;margin:auto;max-height:calc(var(--addrVVH, 100vh) - 32px);transform:translateY(var(--addrModalShift, 0px));transition:transform .18s ease, box-shadow .18s ease}
          [data-theme="dark"] .addr-modal{background:rgba(17,24,39,0.96);box-shadow:0 28px 90px rgba(0,0,0,0.55)}
          .addr-modal-head{padding:14px 16px 10px;font-weight:900;font-size:16px;line-height:1.2;color:#111827}
          [data-theme="dark"] .addr-modal-head{color:#fff}
          .addr-modal-body{padding:0 16px 14px;overflow:auto}
          .addr-modal-label{display:block;font-size:12px;opacity:.75;margin:0 0 8px}
          .addr-modal-input{width:100%;border-radius:14px;border:1px solid rgba(17,24,39,0.14);padding:12px 14px;font-size:16px;line-height:1.2;outline:none}
          .addr-modal-input:focus{border-color:rgba(255,77,117,0.65);box-shadow:0 0 0 4px rgba(255,77,117,0.18)}
          [data-theme="dark"] .addr-modal-input{background:rgba(255,255,255,0.06);border-color:rgba(255,255,255,0.16);color:#fff}
          [data-theme="dark"] .addr-modal-input:focus{border-color:rgba(255,77,117,0.75);box-shadow:0 0 0 4px rgba(255,77,117,0.22)}
          .addr-modal-foot{display:flex;gap:10px;justify-content:flex-end;padding:0 16px 16px}
          .addr-modal-btn{border-radius:999px;border:0;cursor:pointer;font-weight:900;font-size:14px;line-height:1;padding:12px 16px}
          .addr-modal-btn:active{transform:translateY(1px)}
          .addr-modal-btn.cancel{background:rgba(17,24,39,0.08);color:rgba(17,24,39,0.86)}
          [data-theme="dark"] .addr-modal-btn.cancel{background:rgba(255,255,255,0.10);color:rgba(255,255,255,0.92)}
          .addr-modal-btn.confirm{background:var(--ds-gradient);color:#fff;box-shadow:0 14px 34px rgba(255,77,117,0.22)}
          .addr-modal-btn.confirm[disabled]{opacity:.55;cursor:not-allowed;box-shadow:none}
          @media (max-width:520px){.addr-modal-overlay{padding:calc(14px + env(safe-area-inset-top)) 14px calc(14px + env(safe-area-inset-bottom))}.addr-modal{width:100%;max-width:420px;border-radius:18px}}
          .addr-cap-chip{display:none !important}
`;
        document.head.appendChild(style);
    }

    function __renderAddressQuickList(container, input, { onPick } = {}) {
        if (!container) return false;
        __ensureAddrQuickStyles();

        let { saved, recent } = __addrBookSections();

        // Pin best match (exact or "similar" while typing) at top until it changes
const m = __addrBookBestMatch(String(input && input.value || ''));
let pinned = null;
let pinnedScope = '';
if (m && m.entry) {
    pinned = m.entry;
    pinnedScope = m.scope || '';
    if (pinnedScope === 'saved') {
        saved = (saved || []).filter(x => String(x && x.placeId || '') !== String(pinned.placeId || ''));
    } else if (pinnedScope === 'recent') {
        recent = (recent || []).filter(x => String(x && x.placeId || '') !== String(pinned.placeId || ''));
    }
}
        const hasAny = !!(pinned || saved.length || recent.length);
        if (!hasAny) {
            container.style.display = 'none';
            container.innerHTML = '';
            return false;
        }

        const itemHtml = (e, scope) => {
            const s = __formatAddrSuggestion(e || {});
            const placeId = String(e.placeId || '').trim();
            const display = String(e.display || s.display || '').trim();
            const main = String(s.__mainShort || display.split(',')[0] || display).trim();
            const sub = String(s.__subNoCap || '').trim();
            const cap = String(e.postcode || s.__postcode || '').trim();
            const name = String(e.name || '').trim();
            const hasCap = /^\d{5}$/.test(cap);

            const mainLine = escapeHtml(main);
            const subText = escapeHtml(sub || display);
            const nameChip = (scope === 'saved' && name) ? `<span class="addr-saved-chip" title="${escapeHtml(name)}">${escapeHtml(name)}</span>` : ``;
            const fullSpan = display ? `<span class="addr-subtext">${escapeHtml(display)}</span>` : (subText ? `<span class="addr-subtext">${subText}</span>` : ``);

            return `
              <div class="addr-item addr-quick-item" data-placeid="${escapeHtml(placeId)}" data-scope="${escapeHtml(scope)}">
                <div class="addr-lines">
                  <div class="addr-sub">${fullSpan}</div>
                </div>
                <div class="addr-actions">
                  ${nameChip}
                  <button type="button" class="addr-act addr-save" data-act="save" title="${__addrBookIsSaved(placeId) ? 'Rinomina' : 'Salva'}" aria-label="${__addrBookIsSaved(placeId) ? 'Rinomina' : 'Salva'}">${__addrBookIsSaved(placeId) ? __SVG_STAR_FILLED : __SVG_STAR_OUTLINE}</button>
                  <button type="button" class="addr-act addr-del" data-act="del" title="Elimina" aria-label="Elimina">${__SVG_TRASH}</button>
                </div>
              </div>
            `;
        };

        const htmlSaved = saved.length
          ? `<div class="addr-quick-section">
               <div class="addr-quick-head">Salvati</div>
               ${saved.map(e => itemHtml(e, 'saved')).join('')}
             </div>`
          : ``;
        const htmlRecent = recent.length
          ? `<div class="addr-quick-section">
               <div class="addr-quick-head">Recenti</div>
               ${recent.map(e => itemHtml(e, 'recent')).join('')}
             </div>`
          : ``;

        const htmlPinned = pinned
            ? `<div class="addr-quick-section">
                 <div class="addr-quick-head">Già presente</div>
                 ${itemHtml(pinned, pinnedScope).replace('class="addr-item', 'class="addr-item is-pinned')}
               </div>`
            : ``;

        container.style.display = 'block';
        container.innerHTML = `
          <div class="addr-quick">
            ${htmlPinned}
            ${htmlSaved}
            ${htmlRecent}
          </div>
        `;

                // Guard anti click-through: abilita i click solo dopo un tick (evita selezione "fantasma" su tap/focus)
        try {
            container.dataset.quickArmed = '0';
            setTimeout(() => { try { container.dataset.quickArmed = '1'; } catch(_) {} }, 180);
        } catch(_) {}
        container.querySelectorAll('.addr-quick-item').forEach((row) => {
            const placeId = String(row.getAttribute('data-placeid') || '').trim();
            const scope = String(row.getAttribute('data-scope') || '').trim();
            const entry = (() => {
          const { saved, recent } = __addrBookSections();
          const all = (saved || []).concat(recent || []);
          return all.find(x => String(x?.placeId || '') === placeId) || null;
        })();

            row.addEventListener('click', (ev) => {
                try {
                    if (container && container.dataset && container.dataset.quickArmed === '0') { ev.preventDefault(); ev.stopPropagation(); return; }
                } catch(_) {}

                const t = ev && ev.target;
                if (t && t.closest && t.closest('button.addr-act')) return;
                if (!entry) return;

                const picked = { placeId: entry.placeId, display: entry.display, __postcode: entry.postcode || '' };
                try { input.dataset.selected = JSON.stringify(picked); } catch (_) {}
                try { input.dataset.cap = String(entry.postcode || ''); } catch (_) {}
                input.value = String(entry.display || '');

                try { __addrBookUpsertRecent(entry); } catch (_) {}
                try { onPick && onPick(picked); } catch (_) {}
            }, { passive: false });

            const saveBtn = row.querySelector('button.addr-save');
            if (saveBtn) saveBtn.addEventListener('click', async (ev) => {
                ev.preventDefault(); ev.stopPropagation();
                if (!entry) return;
                const isSaved = __addrBookIsSaved(entry.placeId);
                const cur = (__addrBookSections().saved || []).find(x => x.placeId === entry.placeId) || entry;
                const modal = __ensureAddrNameModal();
                const name = await modal.open({
                    title: (isSaved ? 'Rinomina indirizzo' : 'Salva indirizzo'),
                    initialValue: String(cur.name || ''),
                    confirmText: (isSaved ? 'Rinomina' : 'Salva')
                });
                if (name == null) return;
                const n = String(name || '').trim();
                if (!n) return;
                __addrBookUpsertSaved(entry, n);
                __renderAddressQuickList(container, input, { onPick });
            }, { passive: false });

            const delBtn = row.querySelector('button.addr-del');
            if (delBtn) delBtn.addEventListener('click', (ev) => {
                ev.preventDefault(); ev.stopPropagation();
                __addrBookRemove(placeId);
                __renderAddressQuickList(container, input, { onPick });
            }, { passive: false });
        });

        return true;
    }

// ───────────────────────────────────────────────────────────────
// Address suggestions: Roma first + no city-only suggestions
// (keep city/province as context under the street!)
// ───────────────────────────────────────────────────────────────
function __romePriorityText(txt) {
    const s = String(txt || '').toLowerCase();
    if (/\broma\b/.test(s) || /\brm\b/.test(s)) return 2;
    if (s.includes('lazio')) return 1;
    return 0;
}
function __isStreetLikeText(txt) {
    const t = String(txt || '').trim();
    if (!t) return false;
    if (/\d/.test(t)) return true;
    return /\b(via|viale|piazza|p\.za|p\.le|piazzale|largo|corso|vicolo|strada|borgo|lungotevere|lungomare|galleria|circonvallazione|salita|discesa|rampa|passaggio|rotatoria|contrada)\b/i.test(t);
}
function __filterAndSortSuggestions(list) {
    const arr = Array.isArray(list) ? list : [];
    const filtered = arr.filter((item) => {
        const s = __formatAddrSuggestion(item || {});
        const main = String(s.__mainShort || '').trim();
        const sub = String(s.__subNoCap || '').trim();
        if (__isStreetLikeText(main)) return true;
        if (__romePriorityText(sub) > 0) return true;
        return false; // drop pure cities
    });
    filtered.sort((a, b) => {
        const sa = __romePriorityText(String(__formatAddrSuggestion(a || {}).__subNoCap || ''));
        const sb = __romePriorityText(String(__formatAddrSuggestion(b || {}).__subNoCap || ''));
        return sb - sa;
    });
    return filtered;
}

    function getCapState() {
        try {
            const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
            if (!saved || !saved.cap) return { verified: false };
            const isFresh = (Date.now() - (saved.ts || 0)) < CONFIG.capValidityMs;
            return { ...saved, fresh: isFresh };
        } catch { return { verified: false }; }
    }

    // --- MAIN INITIALIZATION ---
    function initInlineModule() {
        const input = $('capAddressInput');
        if (!input) return;

        if($('capModalChangeBtn')) $('capModalChangeBtn').onclick = resetCapState;
        
        setupAutocomplete('capAddressInput', 'capAddrSuggest');
        syncUI();

        // ✅ HOME: mostra subito la quicklist se c'è davvero qualcosa da mostrare
        try { __showInitialAddressQuickList(); } catch (_) {}
// ✅ Auto-refresh: se l'indirizzo è stato ripristinato, rilancia la verifica stock
        setTimeout(autoReverifyAfterRestore, 0);
    }

    function __showInitialAddressQuickList() {
        try {
            const input = $('capAddressInput');
            const inputView = $('capViewInput');
            if (!input || input.disabled) return false;
            if (inputView && inputView.style.display === 'none') return false;
            if (typeof input.getClientRects === 'function' && input.getClientRects().length === 0) return false;
            if (String(input.value || '').trim()) return false;

            setupAutocomplete('capAddressInput', 'capAddrSuggest');
            if (typeof input.__addrShowQuick === 'function') {
                return !!input.__addrShowQuick({ force: true });
            }
        } catch (_) {}
        return false;
    }

    // --- AUTOCOMPLETE LOGIC (Unified Style) ---
    function setupAutocomplete(inputId, suggestId) {
        const input = $(inputId);
        const suggest = $(suggestId);
        if (!input || !suggest) return;
        if (input.__addrWired) return;
        input.__addrWired = true;

        let debounceTimer;
        let __suppressQuickReopenUntil = 0;

        const suppressQuickReopenOnce = () => {
            __suppressQuickReopenUntil = Date.now() + 400;
        };

        try { suggest.addEventListener('pointerdown', suppressQuickReopenOnce, { passive: true, capture: true }); } catch (_) {}
        try { suggest.addEventListener('touchstart', suppressQuickReopenOnce, { passive: true, capture: true }); } catch (_) {}
        try { suggest.addEventListener('mousedown', suppressQuickReopenOnce, { passive: true, capture: true }); } catch (_) {}

        // 1. Clear Button Logic (X)
        const wrapper = input.closest('.cap-input-row') || input.parentElement;
        let clearBtn = wrapper.querySelector('.cap-clear-btn');
        if (!clearBtn) {
            clearBtn = document.createElement('button');
            clearBtn.className = 'cap-clear-btn';
            clearBtn.innerHTML = '&times;';
            wrapper.appendChild(clearBtn);
            
            const toggleClear = () => { clearBtn.style.display = input.value ? 'flex' : 'none'; };
            input.addEventListener('input', toggleClear);
            clearBtn.addEventListener('click', () => {
                input.value = '';
                try { delete input.dataset.selected; } catch(e) {}
                try { delete input.dataset.cap; } catch(e) {}
                clearBtn.style.display = 'none';
                suggest.style.display = 'none';
                showError(null);
                input.focus();
                resetSessionToken(input);
                try {
                    if (typeof input.__addrShowQuick === 'function') {
                        input.__addrShowQuick({ force: true });
                    }
                } catch (_) {}
            });
        }

        
        // Tap-to-see: su focus/tap, se il campo è vuoto o < 3 caratteri mostra la lista rapida
        let __quickOpenGuardTs = 0;
        const showQuickIfNeeded = (opts = {}) => {
            try {
                const skipGuard = !!(opts && opts.skipGuard);
                const now = Date.now();
                if (!skipGuard) {
                    if (now - __quickOpenGuardTs < 160) return;
                    __quickOpenGuardTs = now;
                }

                const qt = String(input.value || '').trim();
                const force = !!(opts && opts.force);
                if (!force && qt) return false;

                // Guard anti "click-through": quando si apre la lista per focus, evita che il click corrente selezioni un recente
                try { suggest.dataset.quickArmed = '0'; } catch (_) {}
                const rendered = __renderAddressQuickList(suggest, input, {
                    onPick: (picked) => {
                        suggest.style.display = 'none';
                        suggest.innerHTML = '';
                        try { resolveAddress(String(picked?.placeId || ''), input, picked || {}); } catch (_) {}
                    }
                });
                try { setTimeout(() => { try { suggest.dataset.quickArmed = '1'; } catch (_) {} }, 180); } catch (_) {}
                return !!rendered;
            } catch (_) {}
            return false;
        };

        const shouldKeepQuickListVisible = () => {
            try {
                if (!input || !suggest || input.disabled) return false;
                if (!input.isConnected || !suggest.isConnected) return false;
                if (String(input.value || '').trim()) return false;
                if (typeof input.getClientRects === 'function' && input.getClientRects().length === 0) return false;
                return true;
            } catch (_) {}
            return false;
        };

        const syncQuickListWhenEmpty = () => {
            try {
                if (Date.now() < __suppressQuickReopenUntil) return false;
                if (!shouldKeepQuickListVisible()) return false;
                return !!showQuickIfNeeded({ force: true, skipGuard: true });
            } catch (_) {}
            return false;
        };

        const scheduleQuickListSync = () => {
            setTimeout(() => {
                try { syncQuickListWhenEmpty(); } catch (_) {}
            }, 0);
        };

        try { input.__addrShowQuick = showQuickIfNeeded; } catch (_) {}

        const openQuickListAfterNativeFocus = () => {
            requestAnimationFrame(() => {
                try {
                    if (document.activeElement === input) showQuickIfNeeded();
                } catch (_) {}
            });
        };

        input.addEventListener('focus', openQuickListAfterNativeFocus, { passive: true });
        input.addEventListener('blur', () => {
            const query = String(input.value || '').trim();
            if (query) return;

            scheduleQuickListSync();
        }, { passive: true });

        document.addEventListener('click', scheduleQuickListSync, true);

        // Enter: se l'utente ha già selezionato un suggerimento, risolvi; altrimenti mostra errore + logga tentativo
        input.addEventListener('keydown', (ev) => {
            if (!ev || ev.key !== 'Enter') return;
            try { ev.preventDefault(); } catch (_) {}
            try { ev.stopPropagation(); } catch (_) {}

            let selectedObj = null;
            try { selectedObj = input.dataset.selected ? JSON.parse(input.dataset.selected) : null; } catch (_) { selectedObj = null; }
            const pid = String(selectedObj?.placeId || selectedObj?.place_id || '').trim();

            if (!pid) {
                showError("Seleziona un indirizzo dai suggerimenti (via + numero civico).");
                try {
                    __logAddressAttempt({
                        context: 'home_init',
                        source: 'cap_modal',
                        status: 'missing_selection',
                        query: String(input.value || ''),
                        display: String(input.value || ''),
                        isAddress: false,
                        reason: 'NO_PLACE_ID'
                    });
                } catch (_) {}
                return;
            }

            try { suggest.style.display = 'none'; suggest.innerHTML = ''; } catch (_) {}
            try { resolveAddress(pid, input, selectedObj || {}); } catch (_) {}
        }, { passive: false });
// 2. Input Event
        input.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            showError(null);
            const query = input.value.trim();
            
            if (!query.length) {
                // Campo vuoto: ripristina Recenti + Salvati, se esistono.
                try {
                    __renderAddressQuickList(suggest, input, {
                        onPick: (picked) => {
                            suggest.style.display = 'none';
                            suggest.innerHTML = '';
                            try { resolveAddress(String(picked?.placeId || ''), input, picked || {}); } catch (_) {}
                        }
                    });
                } catch (_) { suggest.style.display = 'none'; }
                return;
            }

            if (query.length < 3) {
                try { suggest.style.display = 'none'; suggest.innerHTML = ''; } catch (_) {}
                return;
            }

            // UI: Show loading inside suggestion box
            __renderAddressPinnedLoading(suggest, input);

            debounceTimer = setTimeout(async () => {
                const token = ensureSessionToken(input);
                try {
                    // Unified Endpoint URL format
                    const url = `${CONFIG.addressAutocomplete}?q=${encodeURIComponent(query)}&limit=5&country=IT&sessionToken=${encodeURIComponent(token)}`;
                    const res = await fetch(url);
                    const data = await res.json();
                    const list = Array.isArray(data?.suggestions) ? data.suggestions : (Array.isArray(data?.predictions) ? data.predictions : []);
                    
                    renderSuggestions(list, suggest, input);
                } catch (e) { 
                    console.error("Autocomplete error", e); 
                    suggest.style.display = 'none';
                } finally {
                    clearBtn.style.display = 'flex';
                }
            }, 280); // 280ms debounce matching Unified
        });
    }


    function __syncAddrSuggestMetrics(suggestEl) {
      if (!suggestEl) return;
      try {
        const probe = document.createElement('div');
        probe.className = 'addr-item';
        probe.style.position = 'fixed';
        probe.style.left = '-9999px';
        probe.style.top = '0';
        probe.style.visibility = 'hidden';
        probe.style.pointerEvents = 'none';
        probe.innerHTML = `
          <div class="addr-lines">
            <div class="addr-sub"><span class="addr-subtext">Via Alessandro Manzoni 123, 00100 Roma RM, Italia</span></div>
          </div>
          <div class="addr-right"><span class="addr-saved-chip">Casa</span></div>
        `;
        document.body.appendChild(probe);
        const h = Math.round((probe.getBoundingClientRect && probe.getBoundingClientRect().height) ? probe.getBoundingClientRect().height : (probe.offsetHeight || 0));
        probe.remove();
        if (h && h > 0) suggestEl.style.setProperty('--addrItemH', h + 'px');
      } catch(_) {}
    }

    function __renderAddressSuggestionsLoading(suggestEl) {
      if (!suggestEl) return;
      suggestEl.style.display = '';
      suggestEl.setAttribute('role', 'listbox');
      try { __syncAddrSuggestMetrics(suggestEl); } catch(_) {}
      try { suggestEl.setAttribute('data-skel','1'); } catch(_) {}
      // Skeleton (4 rows) to keep dropdown height stable inside modals/cards
      suggestEl.innerHTML = `
        <div class="addr-skel" role="option" aria-disabled="true">
          ${Array.from({ length: 4 }).map(() => `
            <div class="addr-skel-item">
              <div class="addr-skel-lines">
                <div class="addr-skel-line"></div>
                <div class="addr-skel-line small"></div>
              </div>
            </div>
          `).join('')}
        </div>
      `;
    }


    function __renderAddressPinnedLoading(suggestEl, input) {
      if (!suggestEl) return;
      const q = String(input && input.value || '').trim();
      let m = null;
      try { m = __addrBookBestMatch(q); } catch(_) {}
      if (!m || !m.entry || !m.entry.placeId) { __renderAddressSuggestionsLoading(suggestEl); return; }

      // keep dropdown stable: 1 pinned row + 3 skeleton rows = 4 rows total
      suggestEl.style.display = '';
      suggestEl.setAttribute('role', 'listbox');
      try { __syncAddrSuggestMetrics(suggestEl); } catch(_) {}
      try { suggestEl.setAttribute('data-skel','1'); } catch(_) {}

      const entry = m.entry;
      const pid = String(entry.placeId || '').trim();
      const full = String(entry.display || '').trim();
      const name = (m.scope === 'saved') ? String(entry.name || '').trim() : '';
      const chip = (m.scope === 'saved' && name) ? `<div class="addr-right"><span class="addr-saved-chip" title="${escapeHtml(name)}">${escapeHtml(name)}</span></div>` : '';
      const fullSpan = full ? `<span class="addr-subtext">${escapeHtml(full)}</span>` : '';

      suggestEl.innerHTML = `
        <div class="addr-item is-pinned" data-placeid="${escapeHtml(pid)}">
          <div class="addr-lines">
            <div class="addr-sub">${fullSpan}</div>
          </div>
          ${chip}
        </div>
        <div class="addr-skel" aria-hidden="true">
          ${Array.from({ length: 3 }).map(() => `
            <div class="addr-skel-item">
              <div class="addr-skel-lines">
                <div class="addr-skel-line"></div>
                <div class="addr-skel-line small"></div>
              </div>
            </div>
          `).join('')}
        </div>
      `;

      const row = suggestEl.querySelector('.addr-item.is-pinned');
      if (row) row.addEventListener('click', async (ev) => {
        try { if (suggestEl && suggestEl.dataset && suggestEl.dataset.quickArmed === '0') { ev.preventDefault(); ev.stopPropagation(); return; } } catch(_) {}

        try { input.value = full; } catch(_) {}
        try { suggestEl.style.display = 'none'; } catch(_) {}
        try { await resolveAddress(pid, input, { placeId: pid, display: full }); } catch(_) {}
      });
    }


function renderSuggestions(list, container, input) {
    // 1. Filtra risultati API (Google)
    let filtered = __filterAndSortSuggestions(list);
    const q = String(input && input.value || '').trim();

    // 2. RECUPERA MATCH LOCALE (Salvati/Recenti)
    // Usiamo la funzione fixata sopra
    try {
        const m = __addrBookBestMatch(q);
        
        if (m && m.entry && m.entry.placeId) {
            const match = m.entry;
            const scope = m.scope || '';
            const pid = String(match.placeId || '').trim();
            const savedName = match.name || __addrBookSavedName(pid);

            if (pid) {
                // Rimuovi dai risultati API se è già presente (evita duplicati)
                filtered = filtered.filter(x => String(x.placeId || x.place_id || '').trim() !== pid);
                
                // Crea l'oggetto "Pinned"
                const pinned = {
                    placeId: pid,
                    display: match.display,
                    text: match.display, // Fallback per formattazione
                    // Campi speciali per il render
                    __postcode: match.postcode || '',
                    __fromBook: true,
                    __bookScope: scope,
                    __bookName: savedName
                };

                // METTI IN CIMA ALLA LISTA
                filtered.unshift(pinned);
            }
        }
    } catch (e) { console.warn("Local match error", e); }

    // 3. Se la lista combinata è vuota, mostra messaggio
    if (!filtered || filtered.length === 0) {
        try { container.removeAttribute('data-skel'); } catch(_) {}
        container.style.display = 'block';
        container.innerHTML = `<div class="addr-loading" style="padding:12px; font-size:13px; color:#999;">Nessun risultato. Prova a scrivere <b>via</b> + <b>numero civico</b>.</div>`;
        return;
    }
    
    // 4. Render HTML
    container.innerHTML = filtered.map((item, idx) => {
        const s = __formatAddrSuggestion(item);
        
        // Logica Chips (CAP o Civico)
        const hasCap = !!(s.__postcode && /^\d{5}$/.test(String(s.__postcode)));
        const hasNumber = (item.hasNumber === true || item.hasNumber === false) 
            ? item.hasNumber 
            : /\d/.test(s.__mainShort || s.display || '');

        // Chip destro (Nome salvato es. "Casa" o Taglio Preferiti)
        const isPinned = !!item.__fromBook;
        const bookName = (item.__bookName) ? String(item.__bookName) : '';
        
        let rightChip = '';
        if (bookName) {
            rightChip = `<div class="addr-right"><span class="addr-saved-chip" title="${escapeHtml(bookName)}">${escapeHtml(bookName)}</span></div>`;
        } else if (isPinned && item.__bookScope === 'recent') {
             // Opzionale: icona orologio per recenti
             // rightChip = `<div class="addr-right" style="opacity:0.5">↺</div>`;
        }

        const extraClass = isPinned ? ' is-pinned' : '';

        return `
          <div class="addr-item${extraClass}" data-idx="${idx}">
            <div class="addr-lines">
              <div class="addr-sub">
                  <span class="addr-subtext">${escapeHtml(String(s.display || '').trim())}</span>
              </div>
            </div>
            ${rightChip}
          </div>`;
    }).join('');

    try { container.removeAttribute('data-skel'); } catch(_) {}
    container.style.display = 'block';

    // 5. Gestione Click
    container.querySelectorAll('.addr-item').forEach(el => {
        el.addEventListener('click', async () => {
            const item = filtered[el.dataset.idx];
            // Se è pinned, usiamo i suoi dati puliti
            const s = __formatAddrSuggestion(item);
            
            input.value = s.display;
            container.style.display = 'none';
            
            await resolveAddress(item.placeId, input, s);
        });
    });
}



    // --- RESOLVE LOGIC (The Fix) ---
    async function resolveAddress(placeId, input, suggestionObj) {
        if (!input) return;

        // Guard anti doppio trigger (click + focus + re-render)
        try {
            if (input.dataset.__resolving === '1') return;
            input.dataset.__resolving = '1';
        } catch (_) { }

        setLoading(true);

        const queryNow = String(input.value || '').trim();
        const pid = String(placeId || '').trim();
        const attemptId = __newAddressAttemptId('home_init');

        try {
            const token = ensureSessionToken(input);
            const url = `${CONFIG.addressResolve}?placeId=${encodeURIComponent(pid)}&sessionToken=${encodeURIComponent(token)}`;

            const res = await fetch(url);
            const data = await res.json();
            const place = data.place || data || {};

            // 1. Extract CAP (robusto: backend + parsing testo)
            const resolvedCapRaw = String(place.postalCode || place.postcode || '').trim();
            const isAddress = !!place.isAddress; // Backend logic

            let resolvedDisplay = String(place.formattedAddress || place.display || suggestionObj.display || input.value).trim();

            const guessedCap =
                (resolvedDisplay.match(/\b(\d{5})\b/) || [])[1] ||
                (String(suggestionObj && suggestionObj.display || '').match(/\b(\d{5})\b/) || [])[1] ||
                (String(input && input.value || '').match(/\b(\d{5})\b/) || [])[1] ||
                '';

            const resolvedCap = (/^\d{5}$/.test(resolvedCapRaw) ? resolvedCapRaw : (guessedCap || ''));
            const addressComponents = Array.isArray(place.addressComponents) ? place.addressComponents : [];
            const formattedAddress = String(place.formattedAddress || place.display || resolvedDisplay || '').trim();

            // Assicura che il CAP sia presente nel testo mostrato
            if (resolvedCap && !new RegExp(`\\b${resolvedCap}\\b`).test(resolvedDisplay)) {
                resolvedDisplay = (resolvedDisplay ? `${resolvedDisplay}, ${resolvedCap}` : resolvedCap);
            }

            // 2. UNIFIED VALIDATION:
            // Trust the backend 'isAddress' flag OR a valid CAP.
            if (!isAddress || !/^\d{5}$/.test(resolvedCap)) {
                showError("Indirizzo incompleto: scegli una via + numero civico dai suggerimenti (es. “Via … 12, Roma”).");
                try {
                    __logAddressAttempt({
                        context: 'home_init',
                        source: 'cap_modal',
                        status: 'invalid_address',
                        attemptId,
                        query: queryNow,
                        display: String(resolvedDisplay || input.value || ''),
                        resolvedDisplay: String(resolvedDisplay || ''),
                        formattedAddress,
                        addressComponents,
                        placeId: pid,
                        cap: resolvedCap || '',
                        isAddress: false,
                        reason: 'INVALID_OR_MISSING_CAP'
                    });
                } catch (_) {}
                setLoading(false);
                return;
            }

            // 3. Save Last Address (Unified Style)
            try {
                localStorage.setItem(ADDR_CACHE_KEY, JSON.stringify({
                    display: resolvedDisplay,
                    postcode: resolvedCap,
                    placeId: pid,
                    ts: Date.now()
                }));
                try { __addrBookUpsertRecent({ placeId: pid, display: resolvedDisplay, postcode: String(resolvedCap || '') }); } catch (_) {}

            } catch (_) {}

            // 4. Verify Stock (user initiated → log attempts)
            await verifyStock(resolvedCap, resolvedDisplay, {
                userInitiated: true,
                context: 'home_init',
                source: 'cap_modal',
                attemptId,
                query: queryNow,
                placeId: pid,
                display: resolvedDisplay,
                resolvedDisplay,
                formattedAddress,
                addressComponents,
                isAddress: true
            });

        } catch (e) {
            console.error(e);
            showError("Errore nel recupero dell'indirizzo. Riprova.");
            try {
                __logAddressAttempt({
                    context: 'home_init',
                    source: 'cap_modal',
                    status: 'resolve_error',
                    attemptId,
                    query: queryNow,
                    display: String(input && input.value || ''),
                    placeId: pid,
                    reason: String(e && e.message || e || 'resolve_error')
                });
            } catch (_) {}
            setLoading(false);
        } finally {
            try { resetSessionToken(input); } catch (_) {}
            try { delete input.dataset.__resolving; } catch (_) { try { input.dataset.__resolving = '0'; } catch(_) {} }
        }
    }

    async function verifyStock(cap, displayAddr, meta = {}) {

            const ctx = String((meta && meta.context) || 'home_init');
            const userInitiated = !!(meta && meta.userInitiated);
            const placeId = String((meta && (meta.placeId || meta.selectedPlaceId)) || '').trim();
            const query = String((meta && meta.query) || '').trim();
            const attemptId = String((meta && meta.attemptId) || __newAddressAttemptId(ctx)).trim();
            const resolvedDisplay = String((meta && (meta.resolvedDisplay || meta.display)) || displayAddr || '').trim();
            const formattedAddress = String((meta && meta.formattedAddress) || resolvedDisplay || displayAddr || '').trim();
            const addressComponents = Array.isArray(meta && meta.addressComponents) ? meta.addressComponents : [];

            try {

                if (userInitiated) {
                    try {
                        __logAddressAttempt({
                            context: ctx,
                            source: String((meta && meta.source) || 'cap'),
                            status: 'start',
                            attemptId,
                            cap: String(cap || ''),
                            display: String(displayAddr || ''),
                            resolvedDisplay,
                            formattedAddress,
                            addressComponents,
                            placeId,
                            query,
                            isAddress: (meta && typeof meta.isAddress === 'boolean') ? meta.isAddress : undefined
                        });
                    } catch (_) {}
                }

                const res = await fetch(`${CONFIG.stockEndpoint}?cap=${cap}`);


                let data = null;

                try { data = await res.json(); } catch(_) {}


                if (!res.ok) throw new Error(data?.message || "Errore server");

                if (data && data.covered === false) {
                    showError(buildNotServedHtml(data, cap), { html: true });

                    
                    try { __coverageEnsureHandlers(); __coveragePrefillEmailInView(); } catch (_) {}
if (userInitiated) {
                        try {
                            __logAddressAttempt({
                                context: ctx,
                                source: String((meta && meta.source) || 'cap'),
                                status: 'not_served',
                                attemptId,
                                cap: String(cap || ''),
                                display: String(displayAddr || ''),
                                resolvedDisplay,
                                formattedAddress,
                                addressComponents,
                                placeId,
                                query,
                                isAddress: (meta && typeof meta.isAddress === 'boolean') ? meta.isAddress : undefined,
                                covered: false,
                                reason: data.errorCode || 'OUT_OF_COVERAGE'
                            });
                        } catch (_) {}
                    }
                    return;
                }

                if (!data || !data.success) throw new Error(data?.message || "Errore sconosciuto");


                // Success

                const pairs = data.pairs || [];

                const state = { 

                    cap: cap, 

                    display: displayAddr, 

                    verified: true, 

                    ts: Date.now(), 

                    pairs: pairs,

                    cameraId: (data && (data.cameraId || data.camera_id) ? String(data.cameraId || data.camera_id) : (Array.isArray(pairs) && pairs[0] ? String((pairs[0].cameraId || pairs[0].camera_id || pairs[0].id || pairs[0].camera || pairs[0].cam || (Array.isArray(pairs[0]) ? pairs[0][0] : '')) || '') : ''))

                };


                // Persist

                localStorage.setItem(STORAGE_KEY, JSON.stringify(state));


                // Global Events

                document.dispatchEvent(new CustomEvent('stock-updated'));

                document.dispatchEvent(new CustomEvent('cap-check-finish', { detail: state }));


                syncUI();

                if (userInitiated) {
                    try {
                        __logAddressAttempt({
                            context: ctx,
                            source: String((meta && meta.source) || 'cap'),
                            status: 'success',
                            attemptId,
                            cap: String(cap || ''),
                            display: String(displayAddr || ''),
                            resolvedDisplay,
                            formattedAddress,
                            addressComponents,
                            placeId,
                            query,
                            isAddress: (meta && typeof meta.isAddress === 'boolean') ? meta.isAddress : undefined,
                            covered: true
                        });
                    } catch (_) {}
                }


            } catch (e) {

                const msg = e && e.message ? e.message : "Errore connessione.";
                showError(msg);

                if (userInitiated) {
                    try {
                        __logAddressAttempt({
                            context: ctx,
                            source: String((meta && meta.source) || 'cap'),
                            status: 'error',
                            attemptId,
                            cap: String(cap || ''),
                            display: String(displayAddr || ''),
                            resolvedDisplay,
                            formattedAddress,
                            addressComponents,
                            placeId,
                            query,
                            isAddress: (meta && typeof meta.isAddress === 'boolean') ? meta.isAddress : undefined,
                            reason: String(msg || 'error')
                        });
                    } catch (_) {}
                }

            } finally {

                setLoading(false);

            }

        }

    // --- AUTO RE-VERIFY AFTER RESTORE (Home) ---
    // Se abbiamo un indirizzo/CAP verificato in cache, al reload rilanciamo la verifica
    // per riallineare lo stock "live" senza richiedere click.
    let __autoReverifyDone = false;

    function autoReverifyAfterRestore() {
        try {
            if (__autoReverifyDone) return;
            // evita collisioni con altre verifiche globali (se presenti)
            if (window.__capCheckInProgress) return;

            const st = getCapState();
            if (!st || !st.cap || !st.verified || !st.fresh) return;

            // evita refetch immediato se appena verificato e ricaricato
            const ageMs = Date.now() - Number(st.ts || 0);
            if (ageMs < 15000) { __autoReverifyDone = true; return; }

            let displayTxt = st.display || st.cap;
            let last = null;
            try { last = JSON.parse(localStorage.getItem(ADDR_CACHE_KEY) || 'null'); } catch(_) { last = null; }
            if (last && last.display) displayTxt = last.display;

            // prefill input + dataset (utile se l'utente fa "Cambia" subito)
            const addrInput = $('capAddressInput');
            if (addrInput) {
                addrInput.value = String(displayTxt || '');
                addrInput.dataset.cap = String(st.cap || '');
                if (last && last.placeId) {
                    const selected = { placeId: String(last.placeId), display: String(displayTxt || ''), __postcode: String(st.cap || last.postcode || '') };
                    addrInput.dataset.selected = JSON.stringify(selected);
                }
            }

            __autoReverifyDone = true;
            setLoading(true);
            Promise.resolve(verifyStock(String(st.cap), String(displayTxt), { userInitiated: false, context: 'home_init', source: 'auto_restore' })).catch(() => {}).finally(() => {});
        } catch (e) {
            console.warn('autoReverifyAfterRestore failed', e);
        }
    }

    // --- UI HELPERS ---
    function setLoading(isLoading) {
        const loader = $('capLoader'); 
        if (loader) loader.style.display = isLoading ? 'flex' : 'none';

        // ✅ HOME: nasconde la barra input durante la verifica disponibilità
        const inputView = $('capViewInput');
        if (inputView) inputView.classList.toggle('cap-is-loading', !!isLoading);
        const addrInput = $('capAddressInput');
        if (addrInput) addrInput.disabled = !!isLoading;
        if(isLoading) showError(null);
    }
    
    
    // ───────────────────────────────────────────────────────────────
    // Friendly CAP/Address error copy + Not-served CTA (unified)
    // ───────────────────────────────────────────────────────────────
    function normalizeCapErrorMsg(msg) {
      try {
        let m = String(msg || '').trim();
        if (!m) return '';
        const ml = m.toLowerCase();

        // Do not touch rich HTML notices
        if (m.includes('<div') || m.includes('<a') || m.includes('<span')) return m;

        // Coverage / not served
        if (ml.includes('non è servita') || ml.includes('non è ancora servita')) return m;

        // Street number / civic number
        if (ml.includes('numero civico') || ml.includes('civico') || ml.includes('street_number') || ml.includes('street number')) {
          return "Non risulta il numero civico indicato per questa via. Controlla il numero oppure scegli un civico vicino (es. “Via … 12, Roma”) dai suggerimenti.";
        }

        // Incomplete / not an address
        if (ml.includes('indirizzo incompleto') || ml.includes('indirizzo completo') || ml.includes('seleziona un indirizzo') || ml.includes('scegli una via') || ml.includes('no_place_id')) {
          return "Indirizzo incompleto: scegli una via + numero civico dai suggerimenti (es. “Via … 12, Roma”).";
        }

        // Timeout / slow
        if (ml.includes('timeout') || (ml.includes('riprova') && ml.includes('secondo')) || ml.includes('ci stiamo mettendo')) {
          return "Ci stiamo mettendo un attimo… riprova tra qualche secondo.";
        }

        // Connection
        if (ml.includes('connessione') || ml.includes('network') || ml.includes('failed to fetch')) {
          return "Connessione instabile. Riprova tra qualche secondo.";
        }

        // Generic server
        if (ml.includes('errore server') || ml.startsWith('http ')) {
          return "Ops, c’è stato un problema tecnico. Riprova tra poco.";
        }

        return m;
      } catch (_) {
        return String(msg || '');
      }
    }

    
    function escapeHtml(str) {
      return String(str || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }

// ───────────────────────────────────────────────────────────────
// CAP fuori copertura → raccolta email (Firebase)
// ───────────────────────────────────────────────────────────────
const __COVERAGE_WAITLIST_ENDPOINT = (CONFIG && CONFIG.coverageWaitlistEndpoint)
  ? String(CONFIG.coverageWaitlistEndpoint)
  : "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/collectCoverageWaitlist";

const __COVERAGE_PRIVACY_URL = (CONFIG && CONFIG.privacyUrl)
  ? String(CONFIG.privacyUrl)
  : "/policies/privacy-policy";

function __coverageGetPrefillEmail() {
  try {
    const direct = (window.AWI_CUSTOMER_EMAIL || window.__AWI_CUSTOMER_EMAIL || window.customerEmail || '') || '';
    if (direct && /.+@.+\..+/.test(String(direct))) return String(direct).trim();
  } catch (_) {}
  try {
    const ls = localStorage.getItem('florame_customer_email') || '';
    if (ls && /.+@.+\..+/.test(String(ls))) return String(ls).trim();
  } catch (_) {}
  return '';
}

function __coverageGetUtm() {
  try {
    const p = new URLSearchParams(window.location.search || '');
    const get = (k) => {
      const v = p.get(k);
      return v ? String(v).slice(0, 200) : '';
    };
    const utm = {
      source: get('utm_source'),
      medium: get('utm_medium'),
      campaign: get('utm_campaign'),
      content: get('utm_content'),
      term: get('utm_term'),
    };
    // rimuovi vuoti
    Object.keys(utm).forEach(k => { if (!utm[k]) delete utm[k]; });
    return Object.keys(utm).length ? utm : null;
  } catch (_) {
    return null;
  }
}

async function __coverageSubmitWaitlist(payload) {
  const res = await fetch(__COVERAGE_WAITLIST_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true
  });
  let data = null;
  try { data = await res.json(); } catch (_) {}
  if (!res.ok) {
    const msg = (data && (data.message || data.error)) ? String(data.message || data.error) : ('HTTP ' + res.status);
    const err = new Error(msg);
    err.code = (data && data.error) ? String(data.error) : 'HTTP_' + res.status;
    throw err;
  }
  return data || { ok: true };
}

let __coverageHandlersBound = false;

function __coveragePrefillEmailInView() {
  try {
    const email = __coverageGetPrefillEmail();
    if (!email) return;
    const input = document.querySelector('.cap-not-served-email');
    if (input && !String(input.value || '').trim()) input.value = email;
  } catch (_) {}
}

function __coverageEnsureHandlers() {
  if (__coverageHandlersBound) return;
  __coverageHandlersBound = true;

  document.addEventListener('submit', async (e) => {
    const form = e && e.target && e.target.closest ? e.target.closest('form[data-awi-coverage-form="1"]') : null;
    if (!form) return;

    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}

    const emailInput = form.querySelector('input[type="email"]');
    const statusEl = form.parentElement ? form.parentElement.querySelector('[data-awi-coverage-status="1"]') : null;
    const sendBtn = form.querySelector('button[type="submit"]');

    const email = String(emailInput && emailInput.value || '').trim().toLowerCase();
    if (!/.+@.+\..+/.test(email)) {
      if (statusEl) {
        statusEl.className = 'cap-not-served-status is-err';
        statusEl.textContent = 'Inserisci un’email valida.';
      }
      return;
    }

    // Dedup soft (per non chiedere 2 volte nella stessa sessione)
    const dedupKey = 'florame_coverage_waitlist_' + email;
    try {
      if (localStorage.getItem(dedupKey) === '1') {
        if (statusEl) {
          statusEl.className = 'cap-not-served-status is-ok';
          statusEl.textContent = 'Perfetto! Ti avviseremo appena arriviamo in zona ✨';
        }
        return;
      }
    } catch (_) {}

    // Recupera contesto + cap + indirizzo digitato
    const container = form.closest('.cap-not-served');
    const cap = container ? String(container.getAttribute('data-cap') || '') : '';
    const addrInput = document.getElementById('capAddressInput');
    let address = '';
    let placeId = '';

    try {
      if (addrInput) {
        address = String(addrInput.value || '').trim();
        if (addrInput.dataset && addrInput.dataset.selected) {
          const sel = JSON.parse(addrInput.dataset.selected);
          if (sel && sel.display) address = String(sel.display || '').trim();
          if (sel && sel.placeId) placeId = String(sel.placeId || '').trim();
        }
      }
    } catch (_) {}

    // UI loading
    try { if (sendBtn) sendBtn.disabled = true; } catch (_) {}
    if (statusEl) {
      statusEl.className = 'cap-not-served-status';
      statusEl.textContent = 'Invio…';
    }

    try {
      const payload = {
        email,
        cap,
        address,
        placeId,
        context: 'home_cap_inline',
        page: window.location && window.location.href ? String(window.location.href).slice(0, 1000) : '',
        referrer: document.referrer ? String(document.referrer).slice(0, 1000) : '',
        sessionId: (typeof __getSessionId === 'function') ? __getSessionId() : '',
        locale: (document.documentElement && document.documentElement.lang) ? String(document.documentElement.lang).slice(0, 32) : '',
        tz: (() => { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (_) { return ''; } })(),
        ua: navigator && navigator.userAgent ? String(navigator.userAgent).slice(0, 512) : '',
        utm: __coverageGetUtm()
      };

      await __coverageSubmitWaitlist(payload);

      try {
        localStorage.setItem(dedupKey, '1');
        localStorage.setItem('florame_customer_email', email);
      } catch (_) {}

      try {
        __logAddressAttempt({
          source: 'coverage_waitlist',
          context: 'home_cap_inline',
          status: 'not_served',
          covered: false,
          query: address || cap || '',
          display: address || '',
          resolvedDisplay: address || '',
          resolvedCap: cap || '',
          placeId,
          customerEmail: email,
          marketingConsent: false,
        });
      } catch (_) {}

      if (statusEl) {
        statusEl.className = 'cap-not-served-status is-ok';
        statusEl.textContent = 'Perfetto! Ti avviseremo appena iniziamo a consegnare lì ✨';
      }

      // Analytics hook (GTM)
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'coverage_waitlist_submit', cap, context: 'home_cap_inline' });
      } catch (_) {}

    } catch (err) {
      if (statusEl) {
        statusEl.className = 'cap-not-served-status is-err';
        statusEl.textContent = 'Ops, non siamo riusciti a salvare. Riprova tra poco.';
      }
    } finally {
      try { if (sendBtn) sendBtn.disabled = false; } catch (_) {}
    }
  }, true);
}

function buildNotServedHtml(data, cap) {

  const msg =  "Ci dispiace 💔 <br> La zona selezionata non è ancora coperta da florame.ai.";

  return `
    <div class="cap-not-served-wrap">
      <div class="cap-msg cap-not-served-top-msg">${msg}</div>

      <div class="cap-not-served" data-awi-coverage="1" data-cap="${escapeHtml(cap || '')}">
        <div class="cap-not-served-bg" aria-hidden="true">
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9M15 17H18.5905C18.973 17 19.1652 17 19.3201 16.9478C19.616 16.848 19.8475 16.6156 19.9473 16.3198C19.9997 16.1643 19.9997 15.9715 19.9997 15.5859C19.9997 15.4172 19.9995 15.3329 19.9863 15.2524C19.9614 15.1004 19.9024 14.9563 19.8126 14.8312C19.7651 14.7651 19.7047 14.7048 19.5858 14.5858L19.1963 14.1963C19.0706 14.0706 19 13.9001 19 13.7224V10C19 6.134 15.866 2.99999 12 3C8.13401 3.00001 5 6.13401 5 10V13.7224C5 13.9002 4.92924 14.0706 4.80357 14.1963L4.41406 14.5858C4.29477 14.7051 4.23504 14.765 4.1875 14.8312C4.09766 14.9564 4.03815 15.1004 4.0132 15.2524C4 15.3329 4 15.4172 4 15.586C4 15.9715 4 16.1642 4.05245 16.3197C4.15225 16.6156 4.3848 16.848 4.68066 16.9478C4.83556 17 5.02701 17 5.40956 17H9M18.0186 2.01367C19.3978 3.05299 20.4843 4.43177 21.1724 6.01574M5.98197 2.01367C4.60275 3.05299 3.5162 4.43177 2.82812 6.01574"
    stroke="currentColor"
    stroke-width="2.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
        </div>

        <div class="cap-not-served-shell">
          <div class="cap-not-served-copy">
            <div class="cap-not-served-cta">
              <span class="cap-not-served-accent">Lascia</span> <span class="cap-not-served-accent">la tua email</span>:<br>
              <span class="cap-not-served-cta-sub"><span class="cap-not-served-accent">Ti avviseremo</span> per primo appena iniziamo a consegnare anche nella tua zona.</span>
            </div>
          </div>

          <form class="cap-not-served-form" data-awi-coverage-form="1" autocomplete="on">
            <input class="cap-not-served-email" type="email" inputmode="email" autocomplete="email" placeholder="Inserisci la tua email" required />
            <button class="cap-not-served-send" type="submit">Invia</button>
          </form>

          <div class="cap-not-served-status" data-awi-coverage-status="1" aria-live="polite"></div>
          <div class="cap-not-served-foot">Ci aiuti a scegliere le prossime zone: è una metrica fondamentale per la nostra espansione ✨</div>
          <div class="cap-not-served-privacy">Inviando accetti la <a href="${escapeHtml(__COVERAGE_PRIVACY_URL)}" target="_blank" rel="noopener">Privacy Policy</a>.</div>
        </div>
      </div>
    </div>
  `;
}
function showError(msg, opts = {}) {
        const box = $('capMsg');
        if (!box) return;

        if (!msg) {
          box.style.display = 'none';
          box.textContent = '';
          return;
        }

        const useHtml = !!opts.html;
        const safeMsg = useHtml ? String(msg) : normalizeCapErrorMsg(msg);

        if (useHtml) box.innerHTML = safeMsg;
        else box.textContent = safeMsg;

        box.style.display = 'block';
    }

    function syncUI() {

            const state = getCapState();

            const inputView = $('capViewInput');

            const statusView = $('capViewStatus');
        

            if (state.verified && state.fresh) {

                if (inputView) inputView.style.display = 'none';

                if (statusView) statusView.style.display = 'block';
            

                // Logic to prefer "Via Roma, 10" over "00100" in display

                let displayTxt = state.display || state.cap;

                let last = null;

                try {

                    last = JSON.parse(localStorage.getItem(ADDR_CACHE_KEY) || 'null');

                    if (last && last.display) displayTxt = last.display;

                } catch(_) { last = null; }


                // ✅ Ripristina anche il valore input + dataset (utile per auto-verifica e per "Cambia")

                const addrInput = $('capAddressInput');

                if (addrInput) {

                    addrInput.value = String(displayTxt || '');

                    addrInput.dataset.cap = String(state.cap || '');

                    if (last && last.placeId) {

                        const selected = { placeId: String(last.placeId), display: String(displayTxt || ''), __postcode: String(state.cap || last.postcode || '') };

                        addrInput.dataset.selected = JSON.stringify(selected);

                    }

                }


                if ($('capModalDisplayValue')) $('capModalDisplayValue').textContent = displayTxt;

            } else {

                if (inputView) inputView.style.display = 'block';

                if (statusView) statusView.style.display = 'none';

            }

        }
    function resetCapState() {
        localStorage.removeItem(STORAGE_KEY);
        document.dispatchEvent(new CustomEvent('stock-updated'));
        syncUI();
        if($('capAddressInput')) { 
            $('capAddressInput').value = ''; 
            try { $('capAddressInput').focus(); } catch(e){}
            try { __showInitialAddressQuickList(); } catch(_) {}
        }
    }

    // --- INIT ---
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initInlineModule);
    } else {
        initInlineModule();
    }
})();


// --- FIX: Helper mancante ---
function __cleanAddress(str) { 
  // Rimuove spazi extra e normalizza
  return String(str || '').trim(); 
}

// --- FIX: Best Match più robusto ---
function __addrBookBestMatch(typed) {
  const raw = String(typed || '').trim();
  if (!raw) return null;

  // Usa cleanAddress e poi normalizza per il confronto
  const t = __addrKeyLoose(__cleanAddress(raw));
  const tCompactLen = t.replace(/\s/g, '').length;
  if (!t) return null;

  const { saved, recent } = __addrBookSections();

  const scoreOf = (entry) => {
    const cand = __addrKeyLoose(__cleanAddress(String(entry?.display || '')));
    if (!cand) return 0;

    // 1. Corrispondenza Esatta
    if (cand === t) return 100;

    // 2. Prefisso forte (Es. Tu scrivi "Via Ro", salvato è "Via Roma")
    // Questo è fondamentale mentre si digita
    if (cand.startsWith(t)) return 95; 

    // 3. Inverso (Es. Tu scrivi "Via Roma 10", salvato è "Via Roma")
    if (t.startsWith(cand) && cand.length > 5) return 90;

    // Richiede almeno 3 caratteri digitati per fuzzy/contains
    if (tCompactLen < 3) return 0;

    // 4. Contiene la stringa (Es. Scrivi "Roma", salvato "Via Roma")
    if (cand.includes(t)) return 85;

    // 5. Token Overlap (parole sparse)
    const toks = t.split(' ').filter(Boolean).filter(x => x.length >= 2);
    if (!toks.length) return 0;

    let hit = 0;
    for (const tok of toks) {
      if (cand.includes(tok)) hit++;
    }
    const ratio = hit / toks.length;

    if (ratio === 1) return 80; // Tutti i token presenti
    if (ratio >= 0.75) return 70; // Buona parte

    return 0;
  };

  let best = null;
  let bestScope = '';
  let bestScore = 0;

  const scan = (arr, scope) => {
    for (const e of (arr || [])) {
      const sc = scoreOf(e);
      // Priorità ai salvati rispetto ai recenti a parità di score
      if (sc > bestScore || (sc === bestScore && bestScope !== 'saved' && scope === 'saved')) {
        best = e; bestScope = scope; bestScore = sc;
      }
    }
  };

  scan(saved, 'saved');
  scan(recent, 'recent');

  if (!best || !best?.placeId) return null;

  // Soglia minima per mostrare il risultato (65 permette risultati parziali buoni)
  if (bestScore < 65) return null;

  return { entry: best, scope: bestScope, score: bestScore };
}

document.addEventListener('DOMContentLoaded', () => {
  const CONFIG = {
    capKey: 'florame_cap_state',
    endpoints: {
      bouquets: "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/getGeneratedBouquets"
    }
  };

  const UI = {
    availableSection: document.getElementById('availableCarouselSection'),
    availableEmpty: document.getElementById('availableEmptyState'),
    availableContainer: document.getElementById('availableCarousel'),
    communitySection: document.getElementById('communityCarouselSection'),
    communityContainer: document.getElementById('communityCarousel'),
    communityDisclaimer: document.getElementById('communityDisclaimer')
  };

  const Storage = {
    get: () => {
      try {
        const raw = localStorage.getItem(CONFIG.capKey);
        if (!raw) return null;
        const data = JSON.parse(raw);
        // Sessione valida 2 ore (in linea col modulo CAP)
        if ((Date.now() - (data.ts || 0)) > (2 * 60 * 60 * 1000)) return null;
        return data;
      } catch (e) { return null; }
    }
  };

  function getVerifiedCap() {
    const saved = Storage.get();
    if (!saved || !saved.verified) return null;
    const cap = String(saved.cap || '').trim();
    return cap && cap.length >= 4 ? cap : null;
  }

  function isVerified() {
    return !!getVerifiedCap();
  }

  

function setCarouselsMode(verified) {
  // Sempre presenti (skeleton) → niente pop-in. Usiamo solo collapse + flag HTML.
  try { document.documentElement.setAttribute('data-cap-verified', verified ? '1' : '0'); } catch (_) {}

  if (UI.communitySection) UI.communitySection.classList.toggle('is-collapsed', !!verified);
  if (UI.availableSection) UI.availableSection.classList.toggle('is-collapsed', !verified);

  if (!verified) {
    if (UI.availableEmpty) UI.availableEmpty.style.display = 'none';
    // lascia skeleton pronto
  }

  if (UI.communityDisclaimer) UI.communityDisclaimer.style.display = 'none';
}

  // Azioni (Modifica / Aggiungi)
  window.homeEditBouquet = (dataStr) => {
    try {
      const b = JSON.parse(decodeURIComponent(dataStr));
      localStorage.setItem('florame_temp_edit', JSON.stringify({
        composition: b.composition || {},
        packaging: b.packaging || {},
        fromHome: true,
        seed: b.seed,
        promptData: b.promptData
      }));
      window.location.href = '/pages/florame-app?mode=custom&action=edit_temp';
    } catch (e) {
      window.location.href = '/pages/florame-app?mode=custom';
    }
  };

// Delegated click handler for "Modifica" (cards are rendered dynamically)
document.addEventListener('click', function (e) {
  const btn = e && e.target && e.target.closest ? e.target.closest('button[data-home-edit="1"]') : null;
  if (!btn) return;

  try { e.preventDefault(); } catch (_) {}
  try { e.stopPropagation(); } catch (_) {}

  const dataStr = btn.getAttribute('data-bouquet') || btn.dataset.bouquet || '';
  if (!dataStr) return;

  try { window.homeEditBouquet(dataStr); } catch (_) {}
}, true);

  // Delegation: fix click reliability for "Modifica" (avoids inline onclick edge cases)
  document.addEventListener('click', (e) => {
    const btn = e && e.target && e.target.closest ? e.target.closest('button[data-home-edit="1"]') : null;
    if (!btn) return;
    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    try { e.stopImmediatePropagation(); } catch (_) {}
    const ds = String(btn.getAttribute('data-bouquet') || '');
    try {
      if (typeof window.homeEditBouquet === 'function') window.homeEditBouquet(ds);
    } catch (_) {}
  }, true);


  window.homeAddToCart = async (vid) => {
    if (!vid || vid === 'null') return alert("Prodotto non disponibile");
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: vid,
            quantity: 1,
            properties: window.FloramePartner?.getLineProperties?.() || {}
          }]
        })
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Errore carrello');
      }
      window.location.href = '/cart';
    } catch (e) {
      alert(e?.message || "Errore carrello");
    }
  };

  // ==========================================================
  // HOME: CTA dinamiche (Verifica / Notificami / Ti avviseremo)
  // ==========================================================
// ==========================================================
  // HOME: CTA dinamiche (Verifica / Notificami / Ti avviseremo)
  // ==========================================================

  // Email cliente (Shopify login) → disponibile anche per Notificami senza modale
  try {
    const __EMAIL = window.HOMEPAGE_INIT_CUSTOMER_EMAIL ?? null;
    if (__EMAIL) {
      window.AWI_CUSTOMER_EMAIL = __EMAIL;
      try { localStorage.setItem('florame_customer_email', __EMAIL); } catch (_) { }
      try { document.documentElement.setAttribute('data-customer-email', __EMAIL); } catch (_) { }
    }
  } catch (_) {}

  const __HOME_CTA = {
    capKey: CONFIG.capKey,
    waitlistKey: 'florame_back_in_stock_waitlist_v1',
    bouquetEndpoint: "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/getBouquetByProductId",
    awiScriptUrl: window.HOMEPAGE_INIT_AWI_SCRIPT_URL || null,
    availTtlMs: 60 * 1000
  };

  const __homeAvailCache = new Map();       // key: productId::cameraId → { ts, available: true/false/null }
  const __homeAvailInflight = new Map();    // key → Promise

  function __homeReadJson(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; } catch (_) { return fallback; }
  }

  function __homeGetCapState() {
    // Riusa la tua Storage.get (2h TTL)
    try { return Storage.get(); } catch (_) { return null; }
  }

  function __homeIsCapVerified() {
    const s = __homeGetCapState();
    return !!(s && s.verified);
  }

  function __homeGetCameraId() {
    const s = __homeGetCapState();
    const cam = s && (s.cameraId || s.camera_id) ? String(s.cameraId || s.camera_id) : '';
    return cam || '';
  }

  function __homeGetEmail() {
    try {
      const direct = (window.AWI_CUSTOMER_EMAIL || window.__AWI_CUSTOMER_EMAIL || window.customerEmail || '') || '';
      if (direct && /.+@.+\..+/.test(String(direct))) return String(direct).trim();
    } catch (_) {}
    try {
      const ls = localStorage.getItem('florame_customer_email') || '';
      if (ls && /.+@.+\..+/.test(String(ls))) return String(ls).trim();
    } catch (_) {}
    return '';
  }

  function __homeWaitlistList() {
    const list = __homeReadJson(__HOME_CTA.waitlistKey, []);
    return Array.isArray(list) ? list : [];
  }

  function __homeSubKey(btn) {
    const pid = String(btn.dataset.productId || '').trim();
    const vid = String(btn.dataset.variantId || '').trim();
    const base = pid || vid || '';
    const cam = __homeGetCameraId();
    return `${base}::${cam}`;
  }

  function __homeIsSubscribed(btn) {
    const key = __homeSubKey(btn);
    if (!key) return false;
    return __homeWaitlistList().some(x => String(x && x.subKey || '') === key);
  }

  function __homeSyncEditAvailability(btn) {
    try {
      const editButton = btn?.closest?.('.snap-card')?.querySelector?.('button[data-home-edit="1"]');
      if (!editButton) return;
      const canEdit = __homeIsCapVerified()
        && String(btn.dataset.action || '') === 'add'
        && String(btn.dataset.availKnown || '') === '1';
      editButton.hidden = !canEdit;
      editButton.style.display = canEdit ? '' : 'none';
      if (canEdit) editButton.removeAttribute('aria-hidden');
      else editButton.setAttribute('aria-hidden', 'true');
    } catch (_) {}
  }

  function __homeSetBtn(btn, state) {
    if (!btn) return;
    btn.classList.remove('awi-home-cta--verify','awi-home-cta--notify','awi-home-cta--subscribed','awi-home-cta--loading');

    let label = 'Aggiungi';
    let svg = `<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path><path d="M20 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>`;
    let action = 'add';

    if (state === 'verify') {
      btn.classList.add('awi-home-cta--verify');
      label = 'Verifica disponibilità';
      action = 'verify';
      svg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>`;
    } else if (state === 'notify') {
      btn.classList.add('awi-home-cta--notify');
      label = 'Notificami';
      action = 'notify';
      svg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>`;
    } else if (state === 'subscribed') {
      btn.classList.add('awi-home-cta--subscribed');
      label = 'Ti avviseremo';
      action = 'subscribed';
      svg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>`;
    } else if (state === 'loading') {
      btn.classList.add('awi-home-cta--loading');
      label = 'Aggiorno…';
      action = 'loading';
    }

    btn.dataset.action = action;

    // Mantieni <span> label
    const span = btn.querySelector('.awi-home-cta-label');
    if (span) span.textContent = label;

    // Aggiorna SVG (prima node svg)
    const oldSvg = btn.querySelector('svg');
    if (oldSvg) {
      oldSvg.outerHTML = svg;
    } else {
      btn.insertAdjacentHTML('afterbegin', svg);
    }

    // Persistenza UI: evita regressioni a "Aggiungi" quando il DOM viene re-renderizzato
    try {
      btn.dataset.awiUiState = String(state || action || '');
      if (state === 'add' || state === 'notify') btn.dataset.lastGoodState = state;
      if (state === 'subscribed') btn.dataset.lastGoodState = btn.dataset.lastGoodState || 'notify';
    } catch (_) {}
    __homeSyncEditAvailability(btn);
  }

  function __homeAvailCacheKey(productId, cameraId) {
    return `${String(productId || '')}::${String(cameraId || '')}`;
  }

  async function __homeFetchAvailability(productId, cameraId) {
    const pid = String(productId || '').trim();
    if (!pid) return null;

    const key = __homeAvailCacheKey(pid, cameraId);
    const cached = __homeAvailCache.get(key);
    if (cached && (Date.now() - cached.ts) < __HOME_CTA.availTtlMs) return cached.available;

    if (__homeAvailInflight.has(key)) return __homeAvailInflight.get(key);

    const p = (async () => {
      try {
        const url = `${__HOME_CTA.bouquetEndpoint}?productId=${encodeURIComponent(pid)}&cameraId=${encodeURIComponent(cameraId || '')}&_=${Date.now()}`;
        const res = await fetch(url, { cache: 'no-store' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();

        let available = null;
        if (typeof data.available === 'boolean') available = data.available;
        else if (data && data.availabilityByCamera && cameraId && data.availabilityByCamera[cameraId] && typeof data.availabilityByCamera[cameraId].available === 'boolean') {
          available = data.availabilityByCamera[cameraId].available;
        } else if (Array.isArray(data.availableInCameras) && cameraId) {
          available = data.availableInCameras.includes(cameraId);
        }

        __homeAvailCache.set(key, { ts: Date.now(), available });
        return available;
      } catch (e) {
        // Non tornare a "Aggiungi" per errore rete: meglio lasciare stato precedente
        __homeAvailCache.set(key, { ts: Date.now(), available: null });
        return null;
      } finally {
        __homeAvailInflight.delete(key);
      }
    })();

    __homeAvailInflight.set(key, p);
    return p;
  }

  async function __homeUpdateBtn(btn) {
    try {
      if (!btn || btn.dataset.awihomeCta !== '1') return;

      // Senza CAP verificato → Verifica disponibilità
      if (!__homeIsCapVerified()) {
        btn.dataset.availKnown = '0';
        __homeSetBtn(btn, 'verify');
        return;
      }

      // CAP verificato
      const cam = __homeGetCameraId();
      const forceAvail = String(btn.dataset.forceAvailable || '') === '1';

      // Ottimistic: se era già subscribed in locale, mostralo subito ma lo correggiamo dopo se il bouquet è tornato available
      const sub = __homeIsSubscribed(btn);
      if (sub) __homeSetBtn(btn, 'subscribed');

      // Availability
      let available = forceAvail ? true : null;
      if (!forceAvail) {
        const pid = btn.dataset.productId || '';
        available = await __homeFetchAvailability(pid, cam);
      }

      if (available === true) {
        btn.dataset.availKnown = '1';
        __homeSetBtn(btn, 'add');
        btn.classList.add('btn-add'); // mantiene rosa
        return;
      }

      if (available === false) {
        btn.dataset.availKnown = '1';
        __homeSetBtn(btn, sub ? 'subscribed' : 'notify');
        return;
      }

      // unknown (errore rete / cold start) → NON tornare a "Aggiungi" a caso
      btn.dataset.availKnown = '0';

      if (sub) {
        __homeSetBtn(btn, 'subscribed');
      } else if (btn.dataset.lastGoodState) {
        __homeSetBtn(btn, btn.dataset.lastGoodState);
      } else {
        // prima risoluzione: mostra uno stato neutro e riprova a breve
        __homeSetBtn(btn, 'loading');
      }

      // retry soft: utile per cold start / 429 / re-render
      try {
        const now = Date.now();
        const last = Number(btn.dataset.homeRetryAt || 0);
        if (!last || (now - last) > 1400) {
          btn.dataset.homeRetryAt = String(now);
          setTimeout(() => { try { __homeUpdateBtn(btn); } catch (_) {} }, 900);
        }
      } catch (_) {}
    } catch (_) { }
  }

  let __homeRefreshTimer = null;
  function __homeScheduleHomeCtas() {
    if (__homeRefreshTimer) clearTimeout(__homeRefreshTimer);
    __homeRefreshTimer = setTimeout(() => {
      __homeRefreshTimer = null;
      const btns = Array.from(document.querySelectorAll('button[data-awihome-cta="1"]'));
      btns.forEach((b) => { __homeUpdateBtn(b); });
    }, 30);
  }

  function __homeEnsureAwiLoaded() {
    try {
      if (window.__AWI_BOOT || window.openCapModal || window.__awiWaitlist) return Promise.resolve(true);
    } catch (_) {}
    return new Promise((resolve) => {
      const s = document.createElement('script');
      s.src = __HOME_CTA.awiScriptUrl;
      s.async = true;
      s.onload = () => resolve(true);
      s.onerror = () => resolve(false);
      document.head.appendChild(s);
    });
  }

  function __homeScrollToVerycapInline() {
    const selectors = [
      '#verycap-inline',
      '#verycapInline',
      '#verycap',
      '[data-verycap-inline]',
      '#capInlineCard',
      '.cap-dashboard-section'
    ];
    let target = null;
    for (const sel of selectors) {
      try { target = document.querySelector(sel); } catch (_) { target = null; }
      if (target) break;
    }
    if (!target) return;

    // piccolo highlight per guidare l'utente
    try {
      if (!document.getElementById('awiHomeCapHighlightStyle')) {
        const st = document.createElement('style');
        st.id = 'awiHomeCapHighlightStyle';
        st.textContent = `
          .awi-home-cap-highlight { outline: 2px solid rgba(255,255,255,.85); outline-offset: 6px; }
        `;
        document.head.appendChild(st);
      }
      target.classList.add('awi-home-cap-highlight');
      setTimeout(() => { try { target.classList.remove('awi-home-cap-highlight'); } catch (_) {} }, 1200);
    } catch (_) {}

    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) { try { target.scrollIntoView(); } catch (_) {} }

    const input = document.getElementById('capAddressInput');
    if (input) setTimeout(() => { try { input.focus(); } catch (_) {} }, 450);
  }

  // Click handler per CTA su Home (event delegation)
  document.addEventListener('click', async (e) => {
    const btn = e && e.target && e.target.closest ? e.target.closest('button[data-awihome-cta="1"]') : null;
    if (!btn) return;

    let action = String(btn.dataset.action || '');
    const pid = String(btn.dataset.productId || '');
    const vid = String(btn.dataset.variantId || '');
    const handle = String(btn.dataset.handle || '');
    const name = String(btn.dataset.name || 'Bouquet');
        const bouquet = { productId: pid, variantId: vid, handle, name, id: String(btn.dataset.bouquetId || '') };
// Blocca solo se è una nostra CTA
    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    try { e.stopImmediatePropagation(); } catch (_) {}

    if (action === 'verify') {
      // HOME: niente modale qui → scroll verso il VERYCAP inline (come da richiesta)
      __homeScrollToVerycapInline();
      return;
    }

    // Se non sappiamo availability, la verifichiamo "just in time"
    if (action === 'add' && btn.dataset.availKnown !== '1' && __homeIsCapVerified()) {
      btn.classList.add('awi-home-cta--loading');
      const cam = __homeGetCameraId();
      const available = await __homeFetchAvailability(pid, cam);
      btn.classList.remove('awi-home-cta--loading');

      if (available === false) {
        btn.dataset.availKnown = '1';
        __homeSetBtn(btn, __homeIsSubscribed(btn) ? 'subscribed' : 'notify');
        action = String(btn.dataset.action || '');
      } else if (available === true) {
        btn.dataset.availKnown = '1';
        __homeSetBtn(btn, 'add');
        action = String(btn.dataset.action || '');
      } else if (available == null) {
        btn.dataset.availKnown = '0';
        __homeSetBtn(btn, 'loading');
        return;
      }
    }

    if (action === 'add') {
      return window.homeAddToCart(vid);
    }

    // Notify / subscribed: usa la stessa waitlist di AWI (modal email se serve)
    const ok = await __homeEnsureAwiLoaded();
    const w = window.__awiWaitlist;

    if (!ok || !w) {
      console.warn('AWI waitlist non disponibile');
      return;
    }

    const cam = __homeGetCameraId();

    if (action === 'notify') {
      const email = __homeGetEmail() || (typeof w.getEmail === 'function' ? w.getEmail() : '');
      if (email) {
        // ✅ UI immediata ottimistica
        __homeSetBtn(btn, 'subscribed');
        const done = (typeof w.subscribe === 'function') ? w.subscribe(email, bouquet) : false;
        if (!done) __homeSetBtn(btn, 'notify');
        __homeScheduleHomeCtas();
        try { document.dispatchEvent(new CustomEvent('awi-waitlist-updated')); } catch (_) {}
        return;
      }
      // fallback: modale email AWI
      if (typeof w.openModal === 'function') w.openModal(bouquet, 'home');
      return;
    }

    if (action === 'subscribed') {
      // toggle off → UI immediata
      __homeSetBtn(btn, 'notify');
      const removed = (typeof w.unsubscribe === 'function') ? w.unsubscribe(bouquet, cam) : false;
      if (!removed) __homeSetBtn(btn, 'subscribed');
      __homeScheduleHomeCtas();
      try { document.dispatchEvent(new CustomEvent('awi-waitlist-updated')); } catch (_) {}
      return;
    }
  }, true);


  // ----------------------------------------------------------
  // Caroselli (stesso rendering di home-florame)
  // ----------------------------------------------------------
function addCarouselEndArrow(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const section = container.closest('section.carousel-section');
    if (!section) return;

    const topLink = section.querySelector('.section-head a.link-small');
    if (!topLink) return;

    const href = topLink.getAttribute('href');
    if (!href) return;

    // Evita duplicati
    container.querySelectorAll('.snap-card-end').forEach(el => el.remove());

    // Non aggiungere durante skeleton / stato vuoto
    const hasRealCard = container.querySelector('.snap-card:not(.skeleton)');
    if (!hasRealCard) return;

    const labelRaw = (topLink.textContent || '').trim() || 'Esplora';
    const label = labelRaw
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

    container.insertAdjacentHTML('beforeend', `
      <div class="snap-card snap-card-end">
        <a class="snap-link-area snap-end-link" href="${href}" aria-label="${label}">
          <div class="snap-end-wrap">
            <span class="carousel-end-arrow" aria-hidden="true">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h12"></path>
                <path d="M13 6l6 6-6 6"></path>
              </svg>
            </span>
            <span class="snap-end-title">${label}</span>
          </div>
        </a>
        <div class="snap-actions">
          <a class="snap-btn btn-add" href="${href}">Vai</a>
        </div>
      </div>
    `);
  }


  // ----------------------------------------------------------
  // Normalizzazione bouquet (compat con awi.js / backend)
  // ----------------------------------------------------------
  const __HOME_FALLBACK_IMAGE = 'https://cdn.shopify.com/s/files/1/0887/8332/3459/files/Oops_errore.webp?v=1754751168';

  function __homeExtractBouquetList(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.bouquets)) return data.bouquets;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.results)) return data.results;
    if (data.data && Array.isArray(data.data.bouquets)) return data.data.bouquets;
    return [];
  }

  function __homeNormalizeBouquet(b) {
    const obj = b || {};
    const id = obj.id || obj.bouquetId || obj._id || '';
    const name = obj.name || obj.title || 'Bouquet';

    const image =
      obj.image ||
      obj.imageUrl ||
      obj.image_url ||
      (obj.snapshot && (obj.snapshot.url || obj.snapshotUrl)) ||
      obj.url ||
      obj.snapshotUrl ||
      '';

    const handle =
      obj.handle ||
      obj.shopifyHandle ||
      obj.productHandle ||
      (obj.shopify && obj.shopify.handle) ||
      '';

    const price =
      (obj.price != null ? obj.price : null) ??
      obj.productPrice ??
      obj.variantPrice ??
      obj.shopifyPrice ??
      '';

    const variantId = obj.variantId || obj.shopifyVariantId || obj.variant_id || '';
    const productId = obj.productId || obj.shopifyProductId || obj.product_id || '';

    return {
      ...obj,
      id,
      name,
      image,
      handle,
      price,
      variantId,
      productId
    };
  }

  function __homeSanitizeProductUrl(value) {
    const raw = value == null ? '' : String(value).trim();
    if (!raw || /^(?:null|undefined|#)$/i.test(raw)) return '';
    try {
      const parsed = new URL(raw, window.location.origin);
      if (parsed.origin !== window.location.origin) return '';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9_-]*(?:\/)?$/i.test(parsed.pathname)) return '';
      if (/\/(?:null|undefined)(?:\/|$)/i.test(parsed.pathname)) return '';
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch (_) {
      return '';
    }
  }

  function __homeGetProductUrl(bouquet) {
    const directUrl = __homeSanitizeProductUrl(bouquet && bouquet.productUrl);
    if (directUrl) return directUrl;
    try {
      if (typeof window.getProductUrl === 'function') {
        const u = __homeSanitizeProductUrl(window.getProductUrl(bouquet));
        if (u) return u;
      }
    } catch (_) {}
    const h = (bouquet && bouquet.handle) ? String(bouquet.handle).trim() : '';
    if (!/^[a-z0-9][a-z0-9_-]*$/i.test(h) || /^(?:null|undefined)$/i.test(h)) return '#';
    let lang = 'it';
    try {
      const fromApi = window.FlorameI18n && typeof window.FlorameI18n.getLanguage === 'function'
        ? window.FlorameI18n.getLanguage()
        : '';
      const stored = localStorage.getItem('florame_native_lang') || localStorage.getItem('bouquetLanguage') || '';
      const htmlLang = document.documentElement.getAttribute('lang') || '';
      lang = String(fromApi || stored || htmlLang || 'it').slice(0, 2).toLowerCase() === 'en' ? 'en' : 'it';
    } catch (_) {}
    return (lang === 'en' ? '/en/products/' : '/products/') + h;
  }

  function renderCarousel(containerId, items) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const listRaw = Array.isArray(items) ? items : __homeExtractBouquetList(items);
    const list = (listRaw || []).map(__homeNormalizeBouquet);

    container.innerHTML = list.map((item, i) => {
      const dataStr = encodeURIComponent(JSON.stringify({
        id: item.id,
        name: item.name,
        image: item.image,
        price: item.price,
        variantId: item.variantId,
        productId: item.productId,
        composition: item.composition || {},
        packaging: item.packaging || {},
        seed: item.seed,
        promptData: item.promptData
      }));

      const priceNum = (item.price != null && item.price !== '') ? Number(item.price) : NaN;
      const priceVal = Number.isFinite(priceNum) ? priceNum.toFixed(2) : '--';

      const productUrl = __homeGetProductUrl(item);

      // Share + Like (copiati da awi.js, ma robusti)
      let myCreatorId = '';
      try { myCreatorId = String(localStorage.getItem('bouquetCreatorId') || '').trim(); } catch (_) { myCreatorId = ''; }

      let localLikes = [];
      try { localLikes = JSON.parse(localStorage.getItem('awi_liked_bouquets') || '[]') || []; } catch (_) { localLikes = []; }
      if (!Array.isArray(localLikes)) localLikes = [];

      const likedByArr = Array.isArray(item.likedBy) ? item.likedBy : [];
      const foundServerLikeId = likedByArr.find(id =>
        String(id).toLowerCase() === String(myCreatorId).toLowerCase()
      );

      const isLiked = (!!myCreatorId && (localLikes.includes(String(item.id || '')) || !!foundServerLikeId));
      const likeCount = (item.likes != null ? Number(item.likes) : likedByArr.length) || 0;

      const imgSrc = item.image ? String(item.image) : __HOME_FALLBACK_IMAGE;
      const safeName = String(item.name || 'Bouquet').replace(/"/g,'&quot;');

      return `
        <div class="snap-card snap-card-enter" style="--i:${i};" data-bouquet-id="${item.id || ''}">
          <div class="snap-link-area">
            <button class="awi-share-btn" type="button" aria-label="Condividi"
              data-share-url="${productUrl}"
              data-share-title="${safeName}"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
              </svg>
            </button>

            <button class="card-like-btn card-like-btn-modern ${isLiked ? 'liked' : ''}"
              data-id="${item.id || ''}"
              data-count="${likeCount}"
              aria-label="Mi piace"
              type="button"
            >
              <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="${isLiked ? '#ff4d75' : 'none'}" aria-hidden="true">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
              </svg>
              <span class="like-count like-count-modern">${likeCount}</span>
            </button>

            <a href="${productUrl}" class="snap-link-click" ${productUrl === '#' ? 'onclick="event.preventDefault()"' : ''}>
              <img src="${imgSrc}" class="snap-img" loading="lazy" alt="Bouquet"
                onerror="this.src='${__HOME_FALLBACK_IMAGE}'; this.onerror=null;"
              >
              <div class="snap-overlay">
                <div class="snap-tag">${safeName}</div>
                <div class="snap-tag snap-price-tag">€${priceVal}</div>
              </div>
            </a>
          </div>

          <div class="snap-actions">
            <button class="snap-btn btn-edit" type="button" data-home-edit="1" data-bouquet="${dataStr}" hidden aria-hidden="true" style="display:none">
              <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Modifica
            </button>
            <button
              class="snap-btn btn-add awi-home-cta"
              type="button"
              data-awihome-cta="1"
              data-action="add"
              data-bouquet-id="${item.id || ''}"
              data-product-id="${item.productId || ''}"
              data-variant-id="${item.variantId || ''}"
              data-handle="${item.handle || ''}"
              data-name="${safeName}"
              data-source="${containerId}"
              data-force-available="${containerId === 'availableCarousel' ? '1' : '0'}"
            >
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path><path d="M20 20a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
              <span class="awi-home-cta-label">Aggiungi</span>
            </button>
          </div>
        </div>`;
    }).join('');

    addCarouselEndArrow(containerId);
    try { __homeScheduleHomeCtas(); } catch (_) { }
  }

  // --- CARICAMENTO DISPONIBILI (solo dopo verifica) ---
  async function loadAvailableBouquetsForCap(cap) {
    if (!UI.availableSection) return;

    // Senza CAP verificato: lascia la sezione pronta (skeleton) ma collassata via setCarouselsMode
    if (!cap) {
      if (UI.availableEmpty) UI.availableEmpty.style.display = 'none';
      return;
    }

    // Skeleton mentre carica (mantiene altezza/card size stabile)
    if (UI.availableContainer) {
      UI.availableContainer.innerHTML = `<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>`;
    }

    try {
      const res = await fetch(CONFIG.endpoints.bouquets, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cap,
          onlyAvailable: true,
          limit: 15,
          sortField: 'createdAt',
          sortDirection: 'desc'
        })
      });

      const data = await res.json();
      const covered = data && data.covered !== undefined ? !!data.covered : true;
      const list = __homeExtractBouquetList(data);

      // Se non coperto (caso raro qui), mostra comunque empty
      if (!covered) {
        if (UI.availableEmpty) UI.availableEmpty.style.display = 'block';
        if (UI.availableContainer) UI.availableContainer.innerHTML = '';
        return;
      }
if (list.length > 0) {
        if (UI.availableEmpty) UI.availableEmpty.style.display = 'none';
        renderCarousel('availableCarousel', list);
      } else {
        if (UI.availableEmpty) UI.availableEmpty.style.display = 'block';
        if (UI.availableContainer) UI.availableContainer.innerHTML = '';
      }
    } catch (e) {
if (UI.availableEmpty) UI.availableEmpty.style.display = 'block';
      if (UI.availableContainer) UI.availableContainer.innerHTML = '';
    } finally {
      try { __homeScheduleHomeCtas(); } catch (_) {}
    }
  }

  // --- CARICAMENTO ISPIRAZIONI (solo prima della verifica) ---
  async function loadCommunity() {
    try {
      // Skeleton mentre carica (solo se visibile)
      if (UI.communityContainer && UI.communitySection && !UI.communitySection.classList.contains('is-collapsed')) {
        UI.communityContainer.innerHTML = `<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>
<div class="snap-card skeleton" aria-hidden="true"><div class="snap-link-area"><div class="sk sk-media"></div><div class="sk sk-icon sk-icon--left"></div><div class="sk sk-icon sk-icon--right"></div><div class="sk-overlay"><div class="sk sk-line sk-line--title"></div><div class="sk sk-line sk-line--price"></div></div></div><div class="snap-actions"><div class="sk sk-btn sk-btn--outline"></div><div class="sk sk-btn sk-btn--fill"></div></div></div>`;
      }

      const url = `${CONFIG.endpoints.bouquets}?limit=15&sortField=createdAt&sortDirection=desc&_=${Date.now()}`;
      const res = await fetch(url, { cache: 'no-store' });
      const data = await res.json();
      window.__communityList = __homeExtractBouquetList(data);

      if (UI.communitySection && !UI.communitySection.classList.contains('is-collapsed')) {
        renderCarousel('communityCarousel', window.__communityList || []);
      }
    } catch (e) {
      // silent
    } finally {
      try { __homeScheduleHomeCtas(); } catch (_) {}
    }
  }

  // INIT UI
  setCarouselsMode(isVerified());

  // Pre-carica sempre la lista community: serve subito per utenti non verificati e per reset
  loadCommunity();

  // Se già verificato, carica subito i disponibili
  const cap0 = getVerifiedCap();
  if (cap0) loadAvailableBouquetsForCap(cap0);

  // Evento: verifica CAP completata
  document.addEventListener('cap-check-finish', (e) => {
    const detail = (e && e.detail) ? e.detail : null;
    if (!detail) return;

    if (detail.verified) {
      setCarouselsMode(true);
      const cap = String(detail.cap || getVerifiedCap() || '').trim();
      loadAvailableBouquetsForCap(cap);
      return;
    }

    // se non verificato (o reset) resta su Ispirazioni
    setCarouselsMode(false);
    if (UI.communityContainer && (window.__communityList || []).length) {
      renderCarousel('communityCarousel', window.__communityList || []);
    }
  });

  // Evento: reset/cambio indirizzo
  document.addEventListener('stock-updated', () => {
    const st = Storage.get();
    if (!st || !st.verified) {
      setCarouselsMode(false);
      if (UI.communityContainer && (window.__communityList || []).length) {
        renderCarousel('communityCarousel', window.__communityList || []);
      }
      return;
    }
    // ancora verificato (es. bfcache): mantieni disponibili
    setCarouselsMode(true);
    loadAvailableBouquetsForCap(getVerifiedCap());
  });

  // Fix sync (back/forward cache)
  window.addEventListener('pageshow', (e) => {
    if (e && e.persisted) {
      setCarouselsMode(isVerified());
      const cap = getVerifiedCap();
      if (cap) loadAvailableBouquetsForCap(cap);
      else if (UI.communitySection && !UI.communitySection.classList.contains('is-collapsed')) renderCarousel('communityCarousel', window.__communityList || []);
    }
  });

  // ✅ Share + Like handlers (come home-florame)

// ✅ Share button (come awi.js)
if (!window.__HOME_SHARE_HANDLER_V1) {
  window.__HOME_SHARE_HANDLER_V1 = true;

  async function __homeCopyToClipboard(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (_) {}
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return !!ok;
    } catch (_) { return false; }
  }

  function __homeTranslateToast(msg) {
    let text = String(msg == null ? '' : msg);
    try { if (typeof window.__awiLocalizeToastMessage === 'function') text = window.__awiLocalizeToastMessage(text); } catch (_) {}
    try { if (window.FlorameI18n && typeof window.FlorameI18n.t === 'function') text = window.FlorameI18n.t(text); } catch (_) {}
    return text;
  }

  function __homeToast(msg) {
    const text = __homeTranslateToast(msg);
    try { if (typeof window.showToast === 'function') { window.showToast(text); return; } } catch (_) {}
    try { console.log(text); } catch (_) {}
  }

  async function __homeShareUrl(url, title) {
    if (!url) return;
    const abs = (() => { try { return new URL(url, location.origin).href; } catch (_) { return url; } })();
    try {
      if (navigator.share) {
        await navigator.share({ title: title || 'Florame', url: abs });
        return;
      }
    } catch (_) { /* user cancelled */ }
    const ok = await __homeCopyToClipboard(abs);
    __homeToast(ok ? 'Link copiato!' : 'Impossibile copiare il link.');
  }

  document.addEventListener('click', (e) => {
    const btn = e && e.target && e.target.closest ? e.target.closest('button.awi-share-btn') : null;
    if (!btn) return;
    const card = btn.closest('.snap-card');
    if (!card) return;

    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    try { e.stopImmediatePropagation(); } catch (_) {}

    const url = String(btn.getAttribute('data-share-url') || '');
    const title = String(btn.getAttribute('data-share-title') || '');
    __homeShareUrl(url, title);
  }, true);
}

// ✅ Like button (ripreso da awi.js, adattato per Home)
if (!window.__HOME_LIKE_HANDLER_V1) {
  window.__HOME_LIKE_HANDLER_V1 = true;

  async function __homeHandleCardLike(btn) {
    if (!btn) return;

    const bouquetId = String(btn.dataset.id || '').trim();
    const countSpan = btn.querySelector('.like-count');
    let userId = '';
    try { userId = String(localStorage.getItem('bouquetCreatorId') || '').trim(); } catch (_) { userId = ''; }

    if (!bouquetId || !userId) {
      __homeToast('Accedi per mettere mi piace.');
      return;
    }

    const isCurrentlyLiked = btn.classList.contains('liked');
    const isAdding = !isCurrentlyLiked;
    const action = isAdding ? 'like' : 'dislike';

    // Optimistic UI
    btn.classList.toggle('liked');

    let currentCount = parseInt(btn.dataset.count || '0', 10);
    if (isNaN(currentCount)) currentCount = 0;
    const newCount = isAdding ? currentCount + 1 : Math.max(0, currentCount - 1);

    btn.dataset.count = String(newCount);
    if (countSpan) countSpan.textContent = String(newCount);

    // Local storage mirror (stesso key di awi.js)
    try {
      let localLikes = JSON.parse(localStorage.getItem('awi_liked_bouquets') || '[]');
      if (!Array.isArray(localLikes)) localLikes = [];
      if (isAdding) {
        if (!localLikes.includes(bouquetId)) localLikes.push(bouquetId);
      } else {
        localLikes = localLikes.filter(id => String(id) !== bouquetId);
      }
      localStorage.setItem('awi_liked_bouquets', JSON.stringify(localLikes));
    } catch (_) {}

    // Server
    try {
      const endpoint = "https://us-central1-flower-ai-2d7aa.cloudfunctions.net/toggleBouquetLike";
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bouquetId, userId, action })
      });

      const result = await response.json();
      if (!response.ok || !result || !result.success) throw new Error('API');

      // Se siamo nel carosello Preferiti e togliamo il like → rimuovi card
      if (!isAdding) {
        const card = btn.closest('.snap-card');
        const carousel = card && card.closest('.snap-carousel');
        const carouselId = carousel ? String(carousel.id || '') : '';
        if (carouselId === 'favoritesCarousel' && card) {
          card.style.transition = 'all 0.28s ease';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.95)';
          setTimeout(() => {
            try { card.remove(); } catch (_) {}
            try {
              const cont = document.getElementById('favoritesCarousel');
              const empty = document.getElementById('favoritesEmptyState');
              if (cont && cont.querySelectorAll('.snap-card:not(.snap-card-end)').length === 0) {
                cont.style.display = 'none';
                if (empty) empty.style.display = 'flex';
              }
            } catch (_) {}
          }, 280);
        }
      }
    } catch (error) {
      console.error('Errore salvataggio like:', error);

      // Rollback
      btn.classList.toggle('liked');
      btn.dataset.count = String(currentCount);
      if (countSpan) countSpan.textContent = String(currentCount);

      try {
        let localLikes = JSON.parse(localStorage.getItem('awi_liked_bouquets') || '[]');
        if (!Array.isArray(localLikes)) localLikes = [];
        if (isAdding) localLikes = localLikes.filter(id => String(id) !== bouquetId);
        else if (!localLikes.includes(bouquetId)) localLikes.push(bouquetId);
        localStorage.setItem('awi_liked_bouquets', JSON.stringify(localLikes));
      } catch (_) {}
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e && e.target && e.target.closest ? e.target.closest('button.card-like-btn') : null;
    if (!btn) return;
    const card = btn.closest('.snap-card');
    if (!card) return;

    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    try { e.stopImmediatePropagation(); } catch (_) {}

    __homeHandleCardLike(btn);
  }, true);
}
});

const modal = document.getElementById("appModal");
    const openers = [
      document.getElementById("openModalStoreApple"),
      document.getElementById("openModalStoreGoogle"),
    ].filter(Boolean);

    const closeBtn = document.getElementById("closeModalBtn");

    // ✅ Lead: porta l’utente al campo indirizzo
    function focusAddress(){
      const section = document.getElementById('lead');
      const input = document.getElementById('capAddressInput');
      if(section) section.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => { try{ if(input) input.focus(); } catch(e){} }, 420);
    }
    [document.getElementById('focusAddressBtn'), document.getElementById('focusAddressBtn2')]
      .filter(Boolean)
      .forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); focusAddress(); }));


    function openModal(){
      modal.classList.add("active");
      document.body.classList.add("modal-open");
    }
    function closeModal(){
      modal.classList.remove("active");
      document.body.classList.remove("modal-open");
    }

    openers.forEach(el => el.addEventListener("click", (e) => {
      e.preventDefault();
      openModal();
    }));

    closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => { if(e.target === modal) closeModal(); });
    document.addEventListener("keydown", (e) => {
      if(e.key === "Escape" && modal.classList.contains("active")) closeModal();
    });

    const header = document.getElementById("siteHeader");
    let ticking = false;

    function onScroll(){
      const y = window.scrollY || 0;
      header.classList.toggle("scrolled", y > 24);
      ticking = false;
    }
    window.addEventListener("scroll", () => {
      if(!ticking){
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if(entry.isIntersecting){
          entry.target.classList.add("visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    document.querySelectorAll(".reveal").forEach(el => io.observe(el));

    // ✅ CALCOLO ALTEZZA DINAMICA HEADER
    // Questo script aggiorna la variabile --header-offset in base alla reale altezza della topbar
    function updateHeaderOffset(){
      const topbar = document.querySelector('.topbar');
      if(topbar){
        const h = topbar.getBoundingClientRect().height;
        // Aggiungiamo 20px di respiro
        document.documentElement.style.setProperty('--header-offset', (h + 20) + 'px');
      }
    }
    // Aggiorna al caricamento e al ridimensionamento della finestra
    window.addEventListener('load', updateHeaderOffset);
    window.addEventListener('resize', updateHeaderOffset);
    updateHeaderOffset();

/* Smooth carousel entry (stagger) — evita che le card compaiano tutte insieme in modo scattoso */
(() => {
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  const containers = Array.from(document.querySelectorAll('.snap-carousel'));
  if (!containers.length) return;

  function applyStagger(container){
    const all = Array.from(container.children).filter(n =>
      n && n.nodeType === 1 && n.classList &&
      n.classList.contains('snap-card') &&
      !n.classList.contains('skeleton')
    );

    const fresh = all.filter(card => card.dataset.entered !== '1');
    if (!fresh.length) return;

    fresh.forEach((card, i) => {
      card.dataset.entered = '1';
      card.style.setProperty('--i', String(i));
      card.classList.add('snap-card-enter');
      card.addEventListener('animationend', () => {
        // pulizia: evita di lasciare classi/variabili addosso (minor work in future paints)
        try { card.classList.remove('snap-card-enter'); } catch (_) {}
        try { card.style.removeProperty('--i'); } catch (_) {}
      }, { once: true });
    });
  }

  // init + observe updates
  containers.forEach(c => applyStagger(c));

  const mo = new MutationObserver((muts) => {
    const touched = new Set();
    for (const m of muts) {
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) touched.add(m.target);
    }
    if (!touched.size) return;
    requestAnimationFrame(() => requestAnimationFrame(() => { touched.forEach(t => applyStagger(t)); }));
  });
  containers.forEach(c => mo.observe(c, { childList: true }));
})();

/* Desktop-only carousel arrows (prev/next) */
(() => {
  const mq = window.matchMedia && window.matchMedia('(min-width: 981px) and (hover:hover) and (pointer:fine)');
  if (!mq) return;

  function initShell(shell){
    if (!shell || shell.dataset.navInit === '1') return;
    const carousel = shell.querySelector('.snap-carousel');
    const prev = shell.querySelector('.snap-nav--prev');
    const next = shell.querySelector('.snap-nav--next');
    if (!carousel || !prev || !next) return;

    shell.dataset.navInit = '1';

    const step = () => Math.max(280, Math.round(carousel.clientWidth * 0.85));

    prev.addEventListener('click', () => {
      if (prev.disabled) return;
      carousel.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', () => {
      if (next.disabled) return;
      carousel.scrollBy({ left: step(), behavior: 'smooth' });
    });

    let raf = 0;
    const update = () => {
      raf = 0;
      const max = (carousel.scrollWidth - carousel.clientWidth) - 2;
      if (max <= 0) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      const x = carousel.scrollLeft;
      prev.disabled = x <= 2;
      next.disabled = x >= max;
    };
    const schedule = () => {
      if (raf) return;
      raf = requestAnimationFrame(update);
    };

    carousel.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    // When cards are injected, recompute ends
    const mo = new MutationObserver(schedule);
    mo.observe(carousel, { childList: true });

    schedule();
  }

  function initAll(){
    document.querySelectorAll('.snap-carousel-shell[data-carousel-shell]').forEach(initShell);
  }

  if (mq.matches) initAll();
  mq.addEventListener?.('change', (e) => {
    if (e.matches) initAll();
  });
})();

(() => {
  const form = document.getElementById('floristPartnerForm');
  const card = document.getElementById('floristPartnerCard');
  if (!form || !card) return;

  const addressInput = form.querySelector('input[name="address"]');
  const emailInput = form.querySelector('input[name="email"]');
  const titleEl = card.querySelector('.vote-title');
  const subtitleEl = card.querySelector('.vote-subtitle');
  const fitInputs = [addressInput, emailInput].filter(Boolean);
  let fitRaf = 0;
  const fitCanvas = document.createElement('canvas');
  const fitCtx = fitCanvas.getContext('2d');

  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  const getViewportWidth = () => Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  function setError(input, hasError){
    const shell = input && input.closest('.vote-input');
    if (!shell) return;
    shell.style.borderColor = hasError ? 'rgba(230, 91, 125, .62)' : '';
    shell.style.boxShadow = hasError
      ? '0 14px 28px rgba(214, 181, 190, .26), 0 0 0 4px rgba(230, 91, 125, .12)'
      : '';
  }

  function getVoteTextWidth(input, text, fontSize){
    if (!fitCtx || !input) return 0;
    const value = String(text || '').trim() || ' ';
    const styles = window.getComputedStyle(input);
    const fontStyle = styles.fontStyle || 'normal';
    const fontVariant = styles.fontVariant || 'normal';
    const fontWeight = styles.fontWeight || '700';
    const fontFamily = styles.fontFamily || 'sans-serif';
    const letterSpacing = parseFloat(styles.letterSpacing || '0') || 0;

    fitCtx.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}px ${fontFamily}`;
    const measured = fitCtx.measureText(value).width;
    return measured + Math.max(0, value.length - 1) * letterSpacing;
  }

  function fitSingleLine(element, options){
    if (!fitCtx || !element || !options) return;
    const parent = element.parentElement;
    if (!parent) return;

    const parentWidth = parent.clientWidth || parent.getBoundingClientRect().width || 0;
    if (!parentWidth) return;

    const parentStyles = window.getComputedStyle(parent);
    const styles = window.getComputedStyle(element);
    const text = String(options.text || element.textContent || '').replace(/\s+/g, ' ').trim();
    const parentPaddingLeft = parseFloat(parentStyles.paddingLeft || '0') || 0;
    const parentPaddingRight = parseFloat(parentStyles.paddingRight || '0') || 0;
    const paddingLeft = parseFloat(styles.paddingLeft || '0') || 0;
    const paddingRight = parseFloat(styles.paddingRight || '0') || 0;
    const borderLeft = parseFloat(styles.borderLeftWidth || '0') || 0;
    const borderRight = parseFloat(styles.borderRightWidth || '0') || 0;
    const letterSpacing = parseFloat(styles.letterSpacing || '0') || 0;

    const available = Math.max(
      0,
      parentWidth
        - parentPaddingLeft
        - parentPaddingRight
        - (options.parentInset || 0)
        - paddingLeft
        - paddingRight
        - borderLeft
        - borderRight
        - (options.extraInset || 0)
    );
    if (!available) return;

    const fontStyle = styles.fontStyle || 'normal';
    const fontVariant = styles.fontVariant || 'normal';
    const fontWeight = styles.fontWeight || '700';
    const fontFamily = styles.fontFamily || 'sans-serif';
    fitCtx.font = `${fontStyle} ${fontVariant} ${fontWeight} 100px ${fontFamily}`;
    const measured = fitCtx.measureText(text || ' ').width + Math.max(0, (text || ' ').length - 1) * letterSpacing;
    const preferredMin = Math.max(0, Number(options.min) || 0);
    const maxSize = Math.max(preferredMin, Number(options.max) || preferredMin || 0);
    const floorSize = Math.max(
      10,
      Number.isFinite(options.floor)
        ? Number(options.floor)
        : preferredMin
          ? preferredMin * 0.78
          : 10
    );
    const candidate = measured ? (available * 100) / measured : maxSize;
    const boundedCandidate = Math.min(maxSize, candidate);
    const size = boundedCandidate < preferredMin
      ? Math.max(floorSize, boundedCandidate)
      : Math.max(preferredMin, boundedCandidate);
    element.style.setProperty(options.cssVar, `${size.toFixed(2)}px`);
  }

  function getVoteInputMetric(input){
    if (!input) return null;
    const shell = input.closest('.vote-input');
    if (!shell) return null;

    const inputRect = input.getBoundingClientRect();
    if (!inputRect.width) return null;

    const inputStyles = window.getComputedStyle(input);
    let available = input.clientWidth
      - (parseFloat(inputStyles.paddingLeft || '0') || 0)
      - (parseFloat(inputStyles.paddingRight || '0') || 0);

    const visualIcon = shell.querySelector('.vote-input-icon img, .vote-input-icon svg');
    if (visualIcon) {
      const visualRect = visualIcon.getBoundingClientRect();
      const overlap = Math.max(0, Math.ceil(visualRect.right - inputRect.left));
      available -= overlap;
    }

    const sample = String(input.value || input.getAttribute('placeholder') || '').trim();
    return {
      input,
      available: Math.max(available - 4, 0),
      sample
    };
  }

  function scheduleVoteFit(){
    if (fitRaf) return;
    fitRaf = requestAnimationFrame(() => {
      fitRaf = 0;
      const viewportWidth = getViewportWidth();
      fitSingleLine(titleEl, {
        cssVar: '--vote-title-fit-size',
        text: 'Non siamo nella tua zona?',
        min: viewportWidth <= 430 ? 0.98 * 16 : viewportWidth <= 640 ? 1.08 * 16 : viewportWidth <= 980 ? 1.34 * 16 : 1.72 * 16,
        max: viewportWidth <= 430 ? 1.36 * 16 : viewportWidth <= 640 ? 1.62 * 16 : viewportWidth <= 980 ? 2.28 * 16 : 3.1 * 16,
        floor: viewportWidth <= 430 ? 0.82 * 16 : viewportWidth <= 640 ? 0.94 * 16 : viewportWidth <= 980 ? 1.08 * 16 : 1.34 * 16,
        parentInset: viewportWidth <= 640 ? 2 : 0,
        extraInset: 0
      });

      fitSingleLine(subtitleEl, {
        cssVar: '--vote-subtitle-fit-size',
        text: 'Inserisci i dati per rimanere aggiornato',
        min: viewportWidth <= 430 ? 0.68 * 16 : viewportWidth <= 640 ? 0.78 * 16 : viewportWidth <= 980 ? 0.92 * 16 : 1.06 * 16,
        max: viewportWidth <= 430 ? 0.9 * 16 : viewportWidth <= 640 ? 1.02 * 16 : viewportWidth <= 980 ? 1.16 * 16 : 1.5 * 16,
        floor: viewportWidth <= 430 ? 0.62 * 16 : viewportWidth <= 640 ? 0.72 * 16 : viewportWidth <= 980 ? 0.82 * 16 : 0.94 * 16,
        parentInset: viewportWidth <= 640 ? 8 : 0,
        extraInset: 0
      });

      const metrics = fitInputs.map(getVoteInputMetric).filter(Boolean);
      if (!metrics.length) return;

      const minSize = viewportWidth <= 360
        ? 12
        : viewportWidth <= 430
          ? 12.6
          : viewportWidth <= 640
            ? 13.4
            : viewportWidth <= 980
              ? 14.4
              : 17;
      const maxSize = viewportWidth <= 430
        ? 16.2
        : viewportWidth <= 640
          ? 18.4
          : viewportWidth <= 980
            ? 21
            : viewportWidth <= 1280
              ? 28
              : 31;

      let sharedSize = maxSize;
      metrics.forEach((metric) => {
        const baseWidth = getVoteTextWidth(metric.input, metric.sample, 100);
        const candidate = baseWidth ? (metric.available * 100) / baseWidth : maxSize;
        if (Number.isFinite(candidate)) sharedSize = Math.min(sharedSize, candidate);
      });

      sharedSize = Math.max(minSize, Math.min(maxSize, sharedSize));
      fitInputs.forEach((input) => input.style.setProperty('--vote-fit-size', `${sharedSize.toFixed(2)}px`));
    });
  }

  fitInputs.forEach((input) => {
    if (!input) return;
    input.addEventListener('input', () => {
      setError(input, false);
      scheduleVoteFit();
    });
    input.addEventListener('focus', scheduleVoteFit);
    input.addEventListener('blur', scheduleVoteFit);
  });

  if (typeof ResizeObserver === 'function') {
    const resizeObserver = new ResizeObserver(scheduleVoteFit);
    [card, form, titleEl, subtitleEl, ...fitInputs.map((input) => input.closest('.vote-input'))]
      .filter(Boolean)
      .forEach((element) => resizeObserver.observe(element));
  }

  fitInputs.forEach((input) => {
    const iconAsset = input.closest('.vote-input')?.querySelector('.vote-input-icon img');
    if (iconAsset && !iconAsset.complete) {
      iconAsset.addEventListener('load', scheduleVoteFit, { once: true });
    }
  });

  window.addEventListener('resize', scheduleVoteFit, { passive: true });
  window.addEventListener('orientationchange', scheduleVoteFit, { passive: true });
  window.visualViewport?.addEventListener?.('resize', scheduleVoteFit, { passive: true });
  document.fonts?.ready?.then?.(scheduleVoteFit);
  scheduleVoteFit();

  form.addEventListener('submit', (event) => {
    if (form.classList.contains('is-cap-proxy')) return;
    event.preventDefault();

    const address = addressInput ? addressInput.value.trim() : '';
    const email = emailInput ? emailInput.value.trim() : '';
    let hasError = false;

    if (address.length < 4) {
      hasError = true;
      setError(addressInput, true);
    }
    if (!isValidEmail(email)) {
      hasError = true;
      setError(emailInput, true);
    }

    if (hasError) {
      if (card.animate) {
        card.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(-4px)' },
          { transform: 'translateX(4px)' },
          { transform: 'translateX(-2px)' },
          { transform: 'translateX(0)' }
        ], { duration: 320, easing: 'ease' });
      }
      return;
    }

    card.classList.add('is-submitted');
    const label = form.querySelector('.vote-submit-label');
    if (label) label.textContent = 'Richiesta inviata';
    console.log('Florist partner lead:', { address, email });
  });
})();

(function () {
  const voteForm = document.querySelector('.vote-form');
  const capCard = document.getElementById('capInlineCard');
  const addressInput = document.getElementById('capAddressInput');
  const overlay = document.getElementById('capTutorialOverlay');
  const spotlight = document.getElementById('capTutorialSpotlight');
  const bubble = document.getElementById('capTutorialBubble');
  const tutorialMobileMq = window.matchMedia ? window.matchMedia('(max-width: 980px)') : null;

  if (!voteForm || !capCard || !addressInput || !overlay || !spotlight || !bubble) return;

  voteForm.classList.add('is-cap-proxy');

  const proxyInputs = Array.from(voteForm.querySelectorAll('.vote-input-field'));
  let tutorialOpen = false;
  let rafId = null;
  let focusTimerIds = [];

  function isMobileTutorialViewport() {
    return !!(tutorialMobileMq ? tutorialMobileMq.matches : ((window.innerWidth || 0) <= 980));
  }

  function clearFocusTimers() {
    focusTimerIds.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    focusTimerIds = [];
  }

  function scheduleMobileViewportReposition() {
    if (!tutorialOpen || !isMobileTutorialViewport()) return;
    clearFocusTimers();
    [80, 180, 320, 520].forEach(function (delay) {
      focusTimerIds.push(setTimeout(queuePosition, delay));
    });
  }

  function getTutorialViewportBox() {
    const vv = window.visualViewport;
    if (vv && isMobileTutorialViewport()) {
      return {
        top: Number(vv.offsetTop || 0),
        left: Number(vv.offsetLeft || 0),
        width: Number(vv.width || window.innerWidth || 0),
        height: Number(vv.height || window.innerHeight || 0)
      };
    }

    return {
      top: 0,
      left: 0,
      width: Number(window.innerWidth || document.documentElement.clientWidth || 0),
      height: Number(window.innerHeight || document.documentElement.clientHeight || 0)
    };
  }

  function getTargetElement() {
    return addressInput.closest('.cap-input-row') || addressInput.closest('.cap-input-group') || addressInput;
  }

  function queuePosition() {
    if (!tutorialOpen) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(positionTutorial);
  }

  function positionTutorial() {
    const target = getTargetElement();
    if (!target) return;

    const rect = target.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const viewportBox = getTutorialViewportBox();
    const viewportTop = viewportBox.top;
    const viewportLeft = viewportBox.left;
    const viewportWidth = viewportBox.width || window.innerWidth || 0;
    const viewportHeight = viewportBox.height || window.innerHeight || 0;

    const padX = 12;
    const padY = 10;

    spotlight.style.top = (viewportTop + rect.top - padY) + 'px';
    spotlight.style.left = (viewportLeft + rect.left - padX) + 'px';
    spotlight.style.width = (rect.width + padX * 2) + 'px';
    spotlight.style.height = (rect.height + padY * 2) + 'px';

    const bubbleWidth = Math.min(460, Math.max(280, viewportWidth - 32));
    bubble.style.width = bubbleWidth + 'px';

    const preferredLeft = viewportLeft + rect.left + (rect.width / 2) - (bubbleWidth / 2);
    const clampedLeft = Math.max(viewportLeft + 16, Math.min(preferredLeft, viewportLeft + viewportWidth - bubbleWidth - 16));
    bubble.style.left = clampedLeft + 'px';

    bubble.classList.remove('is-above', 'is-below');

    const estimatedHeight = bubble.offsetHeight || 110;
    const gap = 18;
    const roomAbove = rect.top - 16;
    const roomBelow = viewportHeight - rect.bottom - 16;

    if (roomAbove >= estimatedHeight + gap || roomAbove > roomBelow) {
      bubble.classList.add('is-above');
      bubble.style.top = Math.max(viewportTop + 16, viewportTop + rect.top - estimatedHeight - gap) + 'px';
    } else {
      bubble.classList.add('is-below');
      bubble.style.top = Math.min(viewportTop + viewportHeight - estimatedHeight - 16, viewportTop + rect.bottom + gap) + 'px';
    }
  }

  function openTutorial() {
    tutorialOpen = true;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');

    voteForm.classList.add('is-cap-proxy');

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#capInlineCard');
    } else {
      window.location.hash = 'capInlineCard';
    }

    capCard.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    setTimeout(function () {
      addressInput.focus({ preventScroll: true });
      queuePosition();
      scheduleMobileViewportReposition();
    }, 380);

    setTimeout(queuePosition, 700);
    setTimeout(scheduleMobileViewportReposition, 700);
  }

  function closeTutorial() {
    tutorialOpen = false;
    clearFocusTimers();
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
  }

  function interceptVoteForm(event) {
    event.preventDefault();
    openTutorial();
  }

  voteForm.addEventListener('submit', interceptVoteForm);
  voteForm.addEventListener('click', interceptVoteForm);

  proxyInputs.forEach(function (input) {
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('tabindex', '-1');
    input.setAttribute('aria-hidden', 'true');
  });

  addressInput.addEventListener('input', function () {
    if (tutorialOpen && addressInput.value.trim().length > 0) {
      closeTutorial();
    } else {
      queuePosition();
    }
  });

  addressInput.addEventListener('focus', function () {
    if (tutorialOpen) {
      queuePosition();
      scheduleMobileViewportReposition();
    }
  });

  window.addEventListener('resize', queuePosition);
  window.addEventListener('scroll', queuePosition, { passive: true });
  window.addEventListener('orientationchange', queuePosition, { passive: true });
  window.visualViewport?.addEventListener?.('resize', queuePosition, { passive: true });
  window.visualViewport?.addEventListener?.('scroll', queuePosition, { passive: true });
})();
